import React from 'react';
import { SummaryConstants as Constants } from './summaryconstants';
import ApiService from '../Services/ApiService';
import TcciService from '../Services/TcciService';
import OcaService from '../Services/OcaService';
import { getLang, getProvince, formatPrice, getParams, buildLegalContent, customRound } from '../utils';
import { RATE } from '../financeUtils';
import GTMHelper from './gtmHelper';

// import format currency

/*
TODO: THERE IS A MIX OF THREE KIND OF LAYER HERE THAT NEED TO BE SPLITTED
- STRING MANIPULATION UTILS
- JSON PARSING
- OBJECT MODEL WITH BROWSER RULES (SESSION STORAGE)

REFACTOR:
- PROVINCE RETRIEVAL AND INSERT INTO THE CLASS OBJECT INSTEAD OF SINGLE METHOD
*/
export default class SummaryCalculator {
    _myInstance;
    _allDataIsLoaded = false;

    _apiService = null;
    _tcciService = null;

    selectedVehicle = {
        year: new Date().getFullYear(),
        carline: '',
        trim: '',
        model: null,
        packageCode: null,
    }
    selectedLanguage = "";

    _availableTrims = null;
    _selectedModelYear = null;

    _selectedTrim = null;
    _selectedTrimIndex = 0;

    _tradeInValue = 0;
    _downPaymentValue = 0;
    _loyaltyChecked = false;
    _militaryChecked = false;
    _graduateChecked = false;
    _firstTimeOwnerChecked = false;
    _accessoriesValue = 0;
    _annualMileage = 0;
    _financeTerm = null;
    _leaseTerm = null;
    _financeTermIndex = 0;
    _leaseTermIndex = 0;

    _pstRate = 0;
    _gstRate = 0;

    _financialInfo = null;
    _initialFinancial = null;

    _engineAndDrivetrain = null;
    _selectedModelIndex = 0;
    _selectedModel = null;
    _packages = null;
    _selectedPackage = {
        financial: {
            msrp: 0
        }
    };
    _selectedNonModelPackage = {
        financial: {
            msrp: 0
        }
    };
    _selectedWarrantyPackage = {
        financial: {
            msrp: 0
        }
    };
    _selectedConnectedVehiclePackage = {
        financial: {
            msrp: 0
        }
    };
    _selectedAddedProtectionPackage = {
        financial: {
            msrp: 0
        }
    };
    _selectedAppearanceProtectionPackage = {
        financial: {
            msrp: 0
        }
    };

    _selectedPackageIndex = null;
    _selectedNonModelPackageIndex = null;
    _selectedWarrantyIndex = null;
    _selectedConnectedVehicleIndex = null;
    _selectedAddedProtectionIndex= null;
    _selectedAppearanceProtectionIndex = 0;
    _selectedAppearanceProtectionPlanPackageIndex = null;

    _current360Rotation = 18;
    _colours = null;
    _selectedColourInterior = null;
    _selectedColourInteriorIndex = -1;
    _selectedColourExterior = null;
    _selectedColourExteriorIndex = -1;
    _allowedColoursExterior = [];
    _wheels = null;
    _selectedWheel = null;
    _selectedWheelIndex = null;
    _accessories = null;
    _selectedAccessories = [];
    _categories = null;
    _selectedCategory = null;

    _incentives = null;
    _annualMileage = 2;
    _includeFees = true;
    _includeTaxes = false;
    _includeRebates = false;

    _currentStep = 0;
    _previousStep = -1;

    _language = "en";

    _showFinancePrice = true;
    _currentCalculatedCash = 0;

    _currentPurchaseMethod = null;

    constructor() {
        // Create a singleton pattern
        if (SummaryCalculator._instance) {
            return SummaryCalculator._instance
        }
        SummaryCalculator._instance = this;

        this._language = getLang();

        this._apiService = new ApiService();
        this._apiService.language = this._language;
        this._apiService.province = getProvince();

        this._tcciService = new TcciService();
        this._tcciService.language = this._language;
        this._tcciService.province = getProvince();

        this._ocaService = new OcaService();
        this._ocaService.province = getProvince();
    }

    get ShowFinancePrice() {
        return this._showFinancePrice;
    }

    set ShowFinancePrice(value) {
        this._showFinancePrice = value;
        sessionStorage.setItem(Constants.ShowFinancePrice, JSON.stringify(this._showFinancePrice));
    }

    get CurrentCalculatedCash() {
        return this._currentCalculatedCash;
    }

    set CurrentCalculatedCash(value) {
        this._currentCalculatedCash = value;
    }

    //for sending Get local price specific button select to dealer (Finance/Lease/Cash)
    get CurrentPurchaseMethod() {
        return this._currentPurchaseMethod;
    }

    set CurrentPurchaseMethod(value) {
        this._currentPurchaseMethod = value;
    }

    get CurrentStep() {
        return this._currentStep;
    }
    get PreviousStep() {
        return this._previousStep;
    }

    set CurrentStep(value) {
        const gtmHelper = new GTMHelper();

        this._currentStep = value;
        sessionStorage.setItem(Constants.CurrentStep, this._currentStep);
        if (this._previousStep != this._currentStep) {
            gtmHelper.setGTM({ 'action': 'Step' }, false, true);
            this._previousStep = this._currentStep;
            sessionStorage.setItem(Constants.PreviousStep, this._previousStep);
        }
    }

    get Current360Rotation() {
        return this._current360Rotation;
    }

    set Current360Rotation(value) {
        this._current360Rotation = value;
        sessionStorage.setItem(Constants.Current360Rotation, this._current360Rotation);
    }

    get AvailableTrim() {
        return this._availableTrims;
    }

    set AvailableTrim(value) {
        this._availableTrims = value;
        sessionStorage.setItem(Constants.AvailableTrim, JSON.stringify(value));
    }

    get SelectedModelYear() {
        return this._selectedModelYear;
    }

    set SelectedModelYear(value) {
        this._selectedModelYear = value;
        sessionStorage.setItem(Constants.SelectedModelYear, JSON.stringify(this._selectedModelYear));
    }

    get SelectedTrim() {
        return this._selectedTrim;
    }

    set SelectedTrim(value) {
        this._selectedTrim = value;
        sessionStorage.setItem(Constants.SelectedTrim, JSON.stringify(this._selectedTrim));
    }

    get SelectedTrimIndex() {
        return this._selectedTrimIndex;
    }

    set SelectedTrimIndex(value) {
        this._selectedTrimIndex = value;
        sessionStorage.setItem(Constants.SelectedTrimIndex, value);

        this.SelectedTrim = this._availableTrims.trims[this._selectedTrimIndex];
        sessionStorage.setItem(Constants.UrlSlugObjectTrims, JSON.stringify({ 'year': this.selectedVehicle.carline, 'carline': this.selectedVehicle.carline }));

        const financial = this._availableTrims.trims[this._selectedTrimIndex].financial;
        this.FinancialInfo = this.getFinanceObjectWithCalculations(financial, '', '', false, false, false, false, null, null);
    }

    /*
    * This is the entry method that prefetch all the remaining data
    */
    async setSelectedTrimIndex(value) {
        //this._selectedTrimIndex = value?value:this._selectedTrimIndex;
        const tempValue = value !== null ? value : this._selectedTrimIndex;

        this.SelectedTrimIndex = tempValue;

        sessionStorage.setItem(Constants.UrlSlugObjectTrims, JSON.stringify({ 'year': this.selectedVehicle.year, 'carline': this.selectedVehicle.carline }));

        this.selectedVehicle.trim = this.AvailableTrim.trims[tempValue].trim_type.url_slug;
        this.selectedVehicle.model = this.AvailableTrim.trims[tempValue].financial.based_on.model_code;
        this.selectedVehicle.packageCode = this.AvailableTrim.trims[tempValue].financial.based_on.option_code;
        sessionStorage.setItem(Constants.SelectedVehicle, JSON.stringify(tempValue));

        await this.setSelectedModelIndex(0);

        await this.updateSingleLineFromFinancialProvider();
    }

    get FinancialInfo() {
        return this._financialInfo;
    }

    set FinancialInfo(value) {
        this._financialInfo = value;
        sessionStorage.setItem(Constants.FinancialObj, JSON.stringify(value));
    }

    get SelectedTrimUrlSlug() {
        return this._availableTrims.trims[this._selectedTrimIndex].trim_type.url_slug;
    }

    get DefaultTrimUrlSlug() {
        return this._availableTrims.trims[0]?.trim_type?.name;
    }

    get DefaultTrim() {
        return this._availableTrims.trims[0];
    }

    get EngineAndDrivetrain() {
        return this._engineAndDrivetrain;
    }

    set EngineAndDrivetrain(value) {
        this._engineAndDrivetrain = value;

        sessionStorage.setItem(Constants.EngineAndDrivetrain, JSON.stringify(value));
    }

    get SelectedModelIndex() {
        return this._selectedModelIndex;
    }

    get SelectedModel() {
        return this._selectedModel;
    }

    set SelectedModel(value) {
        this._selectedModel = value;

        sessionStorage.setItem(Constants.SelectedModel, JSON.stringify(value));

        sessionStorage.setItem(Constants.VehicleTitle, this.SelectedModel.title);
    }

    set SelectedModelIndex(value) {
        this._selectedModelIndex = value;
        sessionStorage.setItem(Constants.SelectedModelIndex, value);

        this.SelectedModel = this.EngineAndDrivetrain.models[this._selectedModelIndex];

        const finance = this.SelectedModel.financial;
        this.FinancialInfo = this.getFinanceObjectWithCalculations(finance, '', '', false, false, false, false, null, null);
    }

    async setSelectedModelIndex(value) {
        await this.loadEngineAndDrivetrain(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim);

        this.SelectedModelIndex = value;

        await this.loadPackages(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim, this.SelectedModel.model_code, this.SelectedModel.option_code);

        await this.loadColours(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim, this.SelectedModel.model_code, this.SelectedModel.option_code);

        await this.loadWheels(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim, this.SelectedModel.model_code, this.SelectedModel.option_code);

        await this.loadAccessories(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim, this.SelectedModel.model_code, this.SelectedModel.option_code);

        await this.loadPayments(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim, this.SelectedModel.model_code, this.SelectedModel.option_code);

        await this.loadSummary(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim, this.SelectedModel.model_code, this.SelectedModel.option_code);

        await this.loadSpecsData(this.SelectedModel.model_code, this.SelectedModel.option_code);

        // RESET THE APPEARANCE PROTECTION DROP DOWN
        if(!this.SelectedAppearanceProtectionIndex) {
            this.SelectedAppearanceProtectionIndex = 0;
        }

        sessionStorage.setItem(Constants.AllDataIsLoaded, this._allDataIsLoaded = true);
    }

    //store some values from BNS call to send back to BNS OCA
    setOcaValues(loanVals, leaseVals) {
        let key;

        //loan / finance values
        if (loanVals !== null) {
            this.setOcaData('loan', 'cashPrice', loanVals, 'TotalMsrp');
            this.setOcaData('loan', 'rate', loanVals, 'AprRate');
            this._ocaService.loan.rate = this.FinancialInfo.calculatedFinance.financeValues[this.FinancialInfo.financeTerm].rate * 100;
            this.setOcaData('loan', 'term', loanVals, 'LoanPeriod');
            this.setOcaData('loan', 'payment', loanVals, 'MonthlyPaymentWithTaxes');
            this.setOcaData('loan', 'financeAmount', loanVals, 'LoanAmount');
            this._ocaService.loan.Program_End_datetime = loanVals.Program_End_datetime;
            this.setOcaData('loan', 'downPayment', loanVals, 'DownPayment');
            this.setOcaData('loan', 'apr', loanVals, 'AprRate');
        }

        //lease values
        if (leaseVals !== null) {
            this.setOcaData('lease', 'sellingPrice', leaseVals, 'TotalMsrp');
            this.setOcaData('lease', 'residualValue', leaseVals, 'ResidualAmount');
            this.setOcaData('lease', 'term', leaseVals, 'Term');
            this.setOcaData('lease', 'monthlyDepreciation', leaseVals, 'MonthlyDepriciation');
            this.setOcaData('lease', 'totalInterestCost', leaseVals, 'MonthlyInterestCost');
            this.setOcaData('lease', 'interestFactor', leaseVals, 'InterestFactor');
            this.setOcaData('lease', 'baseMonthlyPayment', leaseVals, 'MonthlyPayment');
            this.setOcaData('lease', 'gstHSTRate', leaseVals, 'GstAmount');
            this.setOcaData('lease', 'gstHSTAmountOnRental', leaseVals, 'GstAmount');
            this.setOcaData('lease', 'totalMonthlyPayment', leaseVals, 'MonthlyPaymentWithTaxes');
            this.setOcaData('lease', 'adjustedCapitalizedCost', leaseVals, 'CapitalizedCost');
            this.setOcaData('lease', 'PSTRate', leaseVals, 'PstRate');
            this.setOcaData('lease', 'PSTAmount', leaseVals, 'PstAmount');
            this._ocaService.lease.Program_End_datetime = leaseVals.Program_End_datetime;
            this.setOcaData('lease', 'downPayment', leaseVals, 'DownPayment');
            //this.setOcaData('loan', 'apr', leaseVals, 'AprRate');
            //this._ocaService.lease.apr =  this.getInformationalLeaseAprRate(true);
            this._ocaService.lease.apr = this.FinancialInfo.calculatedLease.leaseValues[this.FinancialInfo.leaseTerm].rate * 100;
        }
    }
    setOcaData(financeType, ocaField, bnsValues, key) {
        this._ocaService[financeType][ocaField] = bnsValues.QuoteItems.filter(filterByID)[0].Value;

        function filterByID(item) {
            if (item.Key == key) {
                return true;
            }
        }
    }

    hasFinancialProviderData() {
        var hasData = true;
        const financeTermToBeDisplayed = [12, 24, 36, 48, 60, 72, 84];
        const leaseTermToBeDisplayed = [36, 39, 42, 45, 48, 51, 54, 57, 60];

        this.FinancialInfo.calculatedFinance.financeValues.forEach((element) => {
            if (financeTermToBeDisplayed.includes(element.term)) {
                if (!element.weekly) {
                    hasData = false;
                }
            }
        });

        this.FinancialInfo.calculatedLease.leaseValues.forEach((element) => {
            if (leaseTermToBeDisplayed.includes(element.term)) {
                if (!element.biWeekly) {
                    hasData = false;
                }
            }
        });

        return hasData;
    }

    /*
        Return the temporary loan response
    */    
    getTemporaryLoanResponse() {
        const mock = require('./loanMock.json');
        return mock;
    }

    /*
        Return the temporary lease response
    */
    getTemporaryLeaseResponse() {
        const mock = require('./leaseMock.json');
        return mock;
    }

    /*
        Return has an error for both loan and lease and also
        when the window.forceContactDealer is set
    */    
    getResponsesHasError() {
        if (window.forceContactDealer)
            return true;
        else {
            const loanHasError = this.getLoanResponsesHasError();
            const leaseHasError = this.getLeaseResponsesHasError();

            return (loanHasError || leaseHasError);
        }
    }

    /*
        Look in the array if there is any data error by comparing all the biweekly values

        Note: There is a special case in the array when the data are not fetched yet, so we include the missing biWeekly property
    */    
    hasDataError(objectsArray) {
        return objectsArray.every(obj => {
            return obj.monthly === objectsArray[0].monthly || !('monthly' in obj)
        });
    }

    /*
        Return if the loan response has an error

        This include communication and data errors
    */    
    getLoanResponsesHasError() {
        const hasCommunicationError = this.FinancialInfo.calculatedFinance.financeValues.some(element => element.hasError);
        const hasDataError = this.hasDataError(this.FinancialInfo.calculatedFinance.financeValues);

        //console.log(hasAnyError, hasDataError);
        return hasCommunicationError || hasDataError;
    }

    /*
        Return if the lease response has an error

        This include communication and data errors
    */    
    getLeaseResponsesHasError() {
        const hasCommunicationError = this.FinancialInfo.calculatedLease.leaseValues.some(element => element.hasError);
        const hasDataError = this.hasDataError(this.FinancialInfo.calculatedLease.leaseValues);

        //console.log(hasAnyError, hasDataError);
        return hasCommunicationError || hasDataError;
    }

    /*
        Update the data from financial provider for both loan and lease
    */
    async loadFromFinancialProvider() {
        // Load data
        await this.updateAllLineFromFinancialProvider();
    }

    /*
        Update the data from financial provider for the selected Finance / Lease term
    */
    async updateSingleLineFromFinancialProvider() {
        this.FinanceTerm = this.FinancialInfo.apr[this.FinanceTermIndex].term;
        this.LeaseTerm = this.FinancialInfo.lease[this.LeaseTermIndex].term;

        await this.updateSingleLeaseLineItem();

        await this.updateSingleLoanLineItem();

        this.FinancialInfo = this.FinancialInfo;        
    }

    /*
        Update the data from financial provider for the selected Lease term
    */    
    async updateSingleLeaseLineItem() {
        if(!this.FinancialInfo || !this.FinancialInfo.calculatedLease || !this.FinancialInfo.calculatedLease.leaseValues)
            return;

        let response = await this._tcciService.sendDataToService(this, this.IncludeFees, this.IncludeRebates, "lease", this.LeaseTerm, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.AnnualMileage);

        // Skip unforseen error by return a temporary empty response
        if (!response || Object.keys(response).length === 0) {
            console.log('Response was empty returning temporary lease response');
            response = this.getTemporaryLeaseResponse();
        }

        // Set taxes on refresh
        sessionStorage.setItem('FinancialProvider_GST', response[0].Lease.Quote.GstPercentage);
        this._gstRate = response[0].Lease.Quote.GstPercentage;
        
        sessionStorage.setItem('FinancialProvider_PST', response[0].Lease.Quote.PstRate)
        this._pstRate = response[0].Lease.Quote.PstRate;

        this.FinancialInfo.calculatedLease.leaseValues[this.LeaseTermIndex] = {...this.FinancialInfo.calculatedLease.leaseValues[this.LeaseTermIndex], ...await this._tcciService.extractLeaseData(response)};

        if (this.AnnualMileage !== 0) {
            const extraDataResponse = await this._tcciService.sendDataToService(this, this.IncludeFees, this.IncludeRebates, "lease", this.LeaseTerm, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, 0);
        
            this.FinancialInfo.calculatedLease.leaseValues[this.LeaseTermIndex].downPaymentLeaseEndValue = this._tcciService.getResidualAmountFromLeaseData(extraDataResponse);
        } else {
            this.FinancialInfo.calculatedLease.leaseValues[this.LeaseTermIndex].downPaymentLeaseEndValue = this._tcciService.getResidualAmountFromLeaseData(response);
        }
    }

    /*
        Update the data from financial provider for the selected Loan term
    */    
    async updateSingleLoanLineItem() {
        if(!this.FinancialInfo || !this.FinancialInfo.calculatedFinance || !this.FinancialInfo.calculatedFinance.financeValues)
            return;

        let response = await this._tcciService.sendDataToService(this, this.IncludeFees, this.IncludeRebates, "loan", this.FinanceTerm, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.AnnualMileage);

        // Skip unforseen error by return a temporary empty response
        if (!response || Object.keys(response).length === 0) {
            console.log('Response was empty returning temporary loan response');
            response = this.getTemporaryLoanResponse();
        }
        
        this.FinancialInfo.calculatedFinance.financeValues[this.FinanceTermIndex] = {...this.FinancialInfo.calculatedFinance.financeValues[this.FinanceTermIndex], ...await this._tcciService.extractLoanData(response)};

        // TODO: SET OCA, NOT IN THE FIRST DELIVERY OF TCCI
        //this.setOcaValues(response[0].Loan, leaseReponse[0].Lease);
    }

    /*
        Update all the line from the financial provider with an specific array term. Do not change array term, it has been selected by marketing team

        NOTE: This function is recommended instead of single line update for UI performance reason
    */
    async updateAllLineFromFinancialProvider() {
        await this.updateAllLoanLinesFromFinancialProvider();
        await this.updateAllLeaseLinesFromFinancialProvider();
    }

    /*
        Update all the lines for loans from the financial provider
    */
    async updateAllLoanLinesFromFinancialProvider() {
        const financeTermToBeDisplayed = [24, 36, 48, 60, 72, 84];

        if(!this.FinancialInfo || !this.FinancialInfo.calculatedFinance || !this.FinancialInfo.calculatedFinance.financeValues)
            return;

        // Do Financing differently from Leasing as the term can be different between the two
        await Promise.all(this.FinancialInfo.calculatedFinance.financeValues.map(async (financeElement) => {
            if (!financeTermToBeDisplayed.includes(financeElement.term))
                return; // skip those that we don't need the data, ultimate hack to save the day

            let response = await this._tcciService.sendDataToService(this, this.IncludeFees, this.IncludeRebates, "loan", financeElement.term, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.AnnualMileage);

            // Look for error from non data from Payment provider
            if (!response || Object.keys(response).length === 0) {
                console.log('Response was empty returning temporary loan response');
                response = this.getTemporaryLoanResponse();
            }

            let extractedData = await this._tcciService.extractLoanData(response);

            //this.setOcaValues(response[0].Loan, null);

            // BUGFIX:Update the array. Do not use return, for some reason the array doesn't get updated.
            const index = this.FinancialInfo.calculatedFinance.financeValues.findIndex(x => x.term === financeElement.term);
            const newObject = {...financeElement, ...extractedData};
            this.FinancialInfo.calculatedFinance.financeValues[index] = newObject;
        }))
        .catch(function (err) {
            console.log('A promise failed to resolve while fetching financial provider service financing data', err);
        });
    }

    /*
        Update all the lines for leases from the financial provider
    */
    async updateAllLeaseLinesFromFinancialProvider() {
        const leaseTermToBeDisplayed = [36, 42, 48, 54, 60];

        if(!this.FinancialInfo || !this.FinancialInfo.calculatedLease || !this.FinancialInfo.calculatedLease.leaseValues)
            return;

        await Promise.all(this.FinancialInfo.calculatedLease.leaseValues.map(async (leaseElement) => {
            if (!leaseTermToBeDisplayed.includes(leaseElement.term))
                return; // skip those that we don't need the data, ultimate hack to save the day
                        
            let extractedData = {};

            // Request for 24000 km used in informational apr (this.AnnualMileage as 0 is 24000 please refer to the annual mileagedrop down)
            if (this.AnnualMileage !== 0) {
                const extraDataResponse = await this._tcciService.sendDataToService(this, this.IncludeFees, this.IncludeRebates, "lease", leaseElement.term, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, 0);
            
                extractedData.downPaymentLeaseEndValue = this._tcciService.getResidualAmountFromLeaseData(extraDataResponse)
            }

            // BUGFIX:Update the array. Do not use return, for some reason the array doesn't get updated.
            const index = this.FinancialInfo.calculatedLease.leaseValues.findIndex(x => x.term === leaseElement.term);
            const newObject = {...leaseElement, ...extractedData};
            this.FinancialInfo.calculatedLease.leaseValues[index] = newObject;
        }));

        await Promise.all(this.FinancialInfo.calculatedLease.leaseValues.map(async (leaseElement) => {
            if (!leaseTermToBeDisplayed.includes(leaseElement.term))
                return; // skip those that we don't need the data, ultimate hack to save the day

            let response = await this._tcciService.sendDataToService(this, this.IncludeFees, this.IncludeRebates, "lease", leaseElement.term, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.AnnualMileage);

            // Look for error from non data from Payment provider
            if (!response || Object.keys(response).length === 0) {
                console.log('Response was empty returning temporary lease response');
                response = this.getTemporaryLeaseResponse();
            }

            // Set taxes
            sessionStorage.setItem('FinancialProvider_GST', response[0].Lease.Quote.GstPercentage)
            this._gstRate = response[0].Lease.Quote.GstPercentage;

            sessionStorage.setItem('FinancialProvider_PST', response[0].Lease.Quote.PstRate)
            this._pstRate = response[0].Lease.Quote.PstRate;

            let extractedData = await this._tcciService.extractLeaseData(response);
            
            if (this.AnnualMileage === 0) {
                extractedData.downPaymentLeaseEndValue = this._tcciService.getResidualAmountFromLeaseData(response);
            }

            // TODO: SET OCA, NOT IN THE FIRST DELIVERY OF TCCI
            //this.setOcaValues(null, response[0].Lease);

            // BUGFIX:Update the array. Do not use return, for some reason the array doesn't get updated.
            const index = this.FinancialInfo.calculatedLease.leaseValues.findIndex(x => x.term === leaseElement.term);
            const newObject = {...leaseElement, ...extractedData};
            this.FinancialInfo.calculatedLease.leaseValues[index] = newObject;
        }))
        .catch(function (err) {
            // log that I have an error, return the entire array;
            console.log('A promise failed to resolve while fetching financial provider leasing data', err);
        });
    }

    get Packages() {
        return this._packages;
    }

    set Packages(value) {
        this._packages = value;

        this._packages.packages.forEach((x, index) => {
            if (x.type === 'model_option_package') {
                this._packages.packages[index].financial.msrp = this._packages.packages[index].financial.msrp - this._financialInfo.msrp;
            }
        });

        sessionStorage.setItem(Constants.Packages, JSON.stringify(this._packages));
    }

    get SelectedPackage() {
        return this._selectedPackage;
    }

    set SelectedPackage(value) {
        if (value) {
            this._selectedPackage = value;

            this.selectedVehicle.packageCode = value.option_code;
            sessionStorage.setItem(Constants.SelectedVehicle, JSON.stringify(this.selectedVehicle));
        } else {
            this._selectedPackage = {
                option_code: this.Packages.default_option.option_code,
                financial: {
                    msrp: 0
                }
            };

            this.selectedVehicle.packageCode = this.Packages.default_option.option_code
            sessionStorage.setItem(Constants.SelectedVehicle, JSON.stringify(this.selectedVehicle));
        }

        sessionStorage.setItem(Constants.SelectedPackage, JSON.stringify(this._selectedPackage));
    }

    get SelectedPackageIndex() {
        return this._selectedPackageIndex;
    }

    set SelectedPackageIndex(index) {
        this._selectedPackageIndex = index;
        sessionStorage.setItem(Constants.SelectedPackageIndex, this._selectedPackageIndex);

        if (index !== null && this.Packages.packages.filter(pack => pack.type === 'model_option_package')[index] ?.type === 'model_option_package') {
            this.SelectedPackage = this.Packages.packages.filter(pack => pack.type === 'model_option_package')[index];
        } else {
            this.SelectedPackage = null;
        }

        this.FinancialInfo = this.getFinanceObjectWithCalculations(this.FinancialInfo, this.TradeInValue, this.DownPaymentValue, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.FinanceTermIndex, this.LeaseTermIndex, this.AnnualMileage);


    }

    /*
        Async method has been added to support financial provider response
    */   
   async setSelectedPackageIndex(index) {
        this.SelectedPackageIndex = index;

        await this.loadColours(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim, this.SelectedModel.model_code, this.SelectedModel.option_code);

        await this.loadWheels(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim, this.SelectedModel.model_code, this.SelectedModel.option_code);

        await this.loadAccessories(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim, this.SelectedModel.model_code, this.SelectedModel.option_code);

        await this.updateSingleLineFromFinancialProvider();
    }

    get SelectedNonModelPackageIndex() {
        return this._selectedNonModelPackageIndex;
    }

    async setSelectedNonModelPackageIndex(index) {
        this.SelectedNonModelPackageIndex = index;

        await this.updateSingleLineFromFinancialProvider();
    }

    set SelectedNonModelPackageIndex(index) {
        this._selectedNonModelPackageIndex = index;
        sessionStorage.setItem(Constants.SelectedNonModelPackageIndex, index);

        const universalPackages = this.Packages.packages.filter(pack => pack.type === 'universal_package');
        if (index !== null && universalPackages) {
            this.SelectedNonModelPackage = universalPackages[index];
        } else {
            this.SelectedNonModelPackage = {
                financial: {
                    msrp: 0
                }
            };
        }

        this.FinancialInfo = this.getFinanceObjectWithCalculations(this.FinancialInfo, this.TradeInValue, this.DownPaymentValue, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.FinanceTermIndex, this.LeaseTermIndex, this.AnnualMileage);
    }

    get SelectedNonModelPackage() {
        return this._selectedNonModelPackage;
    }

    set SelectedNonModelPackage(value) {
        this._selectedNonModelPackage = value;

        sessionStorage.setItem(Constants.SelectedNonModelPackage, JSON.stringify(value));
    }

    /* Selected Warranty Index */
    get SelectedWarrantyIndex() {
        return this._selectedWarrantyIndex;
    }

    async setSelectedWarrantyIndex(index) {
        this.SelectedWarrantyIndex = index;

        await this.updateSingleLineFromFinancialProvider();
    }

    set SelectedWarrantyIndex(index) {
        this._selectedWarrantyIndex = index;
        sessionStorage.setItem(Constants.SelectedWarrantyIndex, index);

        const warrantyPackages = this.Packages.packages.filter(pack => pack.type === 'universal_package' && (pack.package_type === 'Warranty' || pack.package_type === 'Garantie'));
        if (index !== null && warrantyPackages) {
            this.SelectedWarrantyPackage = warrantyPackages[index];
        } else {
            this.SelectedWarrantyPackage = {
                financial: {
                    msrp: 0
                }
            };
        }

        this.FinancialInfo = this.getFinanceObjectWithCalculations(this.FinancialInfo, this.TradeInValue, this.DownPaymentValue, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.FinanceTermIndex, this.LeaseTermIndex, this.AnnualMileage);
    }

    get SelectedWarrantyPackage() {
        return this._selectedWarrantyPackage;
    }

    set SelectedWarrantyPackage(value) {
        this._selectedWarrantyPackage = value;

        sessionStorage.setItem(Constants.SelectedWarrantyPackage, JSON.stringify(value));
    }

    /* Selected Connected Vehicle Index */
    get SelectedConnectedVehicleIndex() {
        return this._selectedConnectedVehicleIndex;
    }

    async setSelectedConnectedVehicleIndex(index) {
        this.SelectedConnectedVehicleIndex = index;

        await this.updateSingleLineFromFinancialProvider();
    }

    set SelectedConnectedVehicleIndex(index) {
        this._selectedConnectedVehicleIndex = index;
        sessionStorage.setItem(Constants.SelectedConnectedVehicleIndex, index);

        const connectivityPackage = this.Packages.connected_services[0];

        this.SelectedConnectedVehiclePackage = {
            financial: {
                msrp: 0
            }
        };

        if(!connectivityPackage)
            return;

        Object.entries(connectivityPackage.subscription).map(([key, value], subscriptionindex) => {
            if(subscriptionindex === index) {
                //console.log('setting subscriptionindex', subscriptionindex);
                this.SelectedConnectedVehiclePackage = value;
            }
        });
        
        this.FinancialInfo = this.getFinanceObjectWithCalculations(this.FinancialInfo, this.TradeInValue, this.DownPaymentValue, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.FinanceTermIndex, this.LeaseTermIndex, this.AnnualMileage);
    }

    get SelectedConnectedVehiclePackage() {
        return this._selectedConnectedVehiclePackage;
    }

    set SelectedConnectedVehiclePackage(value) {
        this._selectedConnectedVehiclePackage = value;

        sessionStorage.setItem(Constants.SelectedConnectedVehiclePackage, JSON.stringify(value));
    }

    /* Added Protection */
    get SelectedAddedProtectionIndex() {
        return this._selectedAddedProtectionIndex;
    }

    async setSelectedAddedProtectionIndex(index) {
        this.SelectedAddedProtectionIndex = index;

        await this.updateSingleLineFromFinancialProvider();
    }

    set SelectedAddedProtectionIndex(index) {
        this._selectedAddedProtectionIndex = index;
        sessionStorage.setItem(Constants.SelectedAddedProtectionIndex, index);

        this.SelectedAddedProtectionPackage = {
            financial: {
                msrp: 0
            }
        }        

        Object.entries(this.Packages.added_protection[0].plans).map(([key, value], planIndex) => {
            if(planIndex === index) {
                //console.log('setting subscriptionindex', subscriptionindex);
                this.SelectedAddedProtectionPackage = value;
            }
        });
                

        this.FinancialInfo = this.getFinanceObjectWithCalculations(this.FinancialInfo, this.TradeInValue, this.DownPaymentValue, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.FinanceTermIndex, this.LeaseTermIndex, this.AnnualMileage);
    }

    get SelectedAddedProtectionPackage() {
        return this._selectedAddedProtectionPackage;
    }
    
    set SelectedAddedProtectionPackage(value) {
        this._selectedAddedProtectionPackage = value;

        sessionStorage.setItem(Constants.SelectedAddedProtectionPackage, JSON.stringify(value));
    }
    /* Added Protection */

    /* Appearance Protection */
    get SelectedAppearanceProtectionPlan() {
        let appearanceProtectionPlan;

        Object.entries(this.Packages.appearance_protection[0].plans).map(([key, value], planIndex) => {
            if(planIndex === Number(this.SelectedAppearanceProtectionIndex)) {
                appearanceProtectionPlan = value;
            }
        });

        return appearanceProtectionPlan;
    }

    get SelectedAppearanceProtectionIndex() {
        return this._selectedAppearanceProtectionIndex;
    }

    setSelectedAppearanceProtectionIndex(index) {
        this._selectedAppearanceProtectionIndex = index;
    }

    set SelectedAppearanceProtectionIndex(index) {
        this._selectedAppearanceProtectionIndex = index;
        sessionStorage.setItem(Constants.SelectedAppearanceProtectionIndex, index);

        this.SelectedAppearanceProtectionPlansIndex = null;
    }


    get SelectedAppearanceProtectionPlansIndex() {
        return this._selectedAppearanceProtectionPlanPackageIndex;
    }

    async setSelectedAppearanceProtectionPlansIndex(index) {
        this.SelectedAppearanceProtectionPlansIndex = index;

        await this.updateSingleLineFromFinancialProvider();
    }

    set SelectedAppearanceProtectionPlansIndex(index) {
        this._selectedAppearanceProtectionPlanPackageIndex = index;
        sessionStorage.setItem(Constants.SelectedAppearanceProtectionPlanPackageIndex, index);
       
        if (index !== null) {
            Object.entries(this.Packages.appearance_protection[0].plans).map(([key, value], planIndex) => {
                if(planIndex === Number(this.SelectedAppearanceProtectionIndex)) {

                    Object.entries(value.packages).map(([key, appearanceProtectionPlansPackage], packageIndex) => {
                        if(packageIndex === Number(index)) {
                            this.SelectedAppearanceProtectionPlansPackage = appearanceProtectionPlansPackage;  
                            this.SelectedAppearanceProtectionPlansPackage.key = key;            
                        }
                    });
        
                }
            })

            //const appearanceProtectionPlansPackage = this.Packages.appearance_protection.plans[this._selectedAppearanceProtectionIndex].packages[index];
            //this.SelectedAppearanceProtectionPlansPackage = appearanceProtectionPlansPackage;
        } else {
            this.SelectedAppearanceProtectionPlansPackage = {
                financial: {
                    msrp: 0
                }
            };
        }

        this.FinancialInfo = this.getFinanceObjectWithCalculations(this.FinancialInfo, this.TradeInValue, this.DownPaymentValue, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.FinanceTermIndex, this.LeaseTermIndex, this.AnnualMileage);
    }

    get SelectedAppearanceProtectionPlansPackage() {
        return this._selectedAppearanceProtectionPackage;
    }

    set SelectedAppearanceProtectionPlansPackage(value) {
        this._selectedAppearanceProtectionPackage = value;
        sessionStorage.setItem(Constants.SelectedAppearanceProtectionPlansPackage, JSON.stringify(value));
    }
    /* Appearance Protection */

    get Colours() {
        return this._colours;
    }
    set Colours(value) {
        this._colours = value;
        sessionStorage.setItem(Constants.Colours, JSON.stringify(value));

        const financial = value.financial;
        this.FinancialInfo = this.getFinanceObjectWithCalculations(financial, this._tradeInValue, this._downPaymentValue, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.FinanceTermIndex, this.LeaseTermIndex, this.AnnualMileage);
    }

    set InitialFinancial(value) {
        this._initialFinancial = value;
        sessionStorage.setItem(Constants.InitialFinance, JSON.stringify(value));
    }
    get InitialFinancial() {
        if (sessionStorage.getItem(Constants.InitialFinance)) {
            this._initialFinancial = JSON.parse(sessionStorage.getItem(Constants.InitialFinance));
        }
        return this._initialFinancial;
    }

    set SelectedColourInterior(value) {
        this._selectedColourInterior = value;
        sessionStorage.setItem(Constants.SelectedInteriorColour, JSON.stringify(value));

        this.FinancialInfo = this.getFinanceObjectWithCalculations(this.FinancialInfo, this._tradeInValue, this._downPaymentValue, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.FinanceTermIndex, this.LeaseTermIndex, this.AnnualMileage);
    }

    get SelectedColourInterior() {
        return this._selectedColourInterior;
    }

    async setSelectedColourInteriorIndex(value) {
        this.SelectedColourInteriorIndex = value;

        await this.updateSingleLineFromFinancialProvider();
    }

    set SelectedColourInteriorIndex(value) {
        this._selectedColourInteriorIndex = value;
        sessionStorage.setItem(Constants.SelectedColourInteriorIndex, value);
        this.SelectedColourInterior = this.Colours.visual.interiors[value];
    }

    get SelectedColourInteriorIndex() {
        return this._selectedColourInteriorIndex;
    }

    get SelectedColourExterior() {
        return this._selectedColourExterior;
    }
    set SelectedColourExterior(value) {
        this._selectedColourExterior = value;
        sessionStorage.setItem(Constants.SelectedExteriorColour, JSON.stringify(this._selectedColourExterior));
    }

    /*
        Async methods has been added to support UI interaction which need to wait for the financial provider response
    */
    async setSelectedColourExteriorIndex(value) {
        this.SelectedColourExteriorIndex = value;

        await this.updateSingleLineFromFinancialProvider();
    }

    set SelectedColourExteriorIndex(value) {
        this._selectedColourExteriorIndex = value;
        sessionStorage.setItem(Constants.SelectedColourExteriorIndex, value);
        this.SelectedColourExterior = Object.entries(this.Colours.visual.exteriors)[value][1];

        this.FinancialInfo = this.getFinanceObjectWithCalculations(this.FinancialInfo, this._tradeInValue, this._downPaymentValue, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.FinanceTermIndex, this.LeaseTermIndex, this.AnnualMileage);
    }

    get SelectedColourExteriorIndex() {
        return this._selectedColourExteriorIndex;
    }

    set AllowedColoursExterior(value) {
        this._allowedColoursExterior = value;
        sessionStorage.setItem(Constants.AllowedColoursExterior, JSON.stringify(this._allowedColoursExterior));
    }
    get AllowedColoursExterior() {
        return this._allowedColoursExterior;
    }

    set Wheels(value) {
        this._wheels = value;
        sessionStorage.setItem(Constants.Wheels, JSON.stringify(value));

        const financial = value.financial;
        this.FinancialInfo = this.getFinanceObjectWithCalculations(financial, this._tradeInValue, this._downPaymentValue, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.FinanceTermIndex, this.LeaseTermIndex, this.AnnualMileage);
    }
    get Wheels() {
        return this._wheels;
    }

    set SelectedWheel(value) {
        this._selectedWheel = value;
        sessionStorage.setItem(Constants.SelectedWheel, JSON.stringify(value));

        const financial = this.InitialFinancial;
        this.FinancialInfo = this.getFinanceObjectWithCalculations(financial, this._tradeInValue, this._downPaymentValue, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.FinanceTermIndex, this.LeaseTermIndex, this.AnnualMileage);
    }

    get SelectedWheel() {
        return this._selectedWheel;
    }

    set SelectedWheelIndex(value) {
        this._selectedWheelIndex = value;
        sessionStorage.setItem(Constants.SelectedWheelIndex, value);

        if (value !== null) {
            this.SelectedWheel = Object.entries(this.Wheels.wheels)[value][1];
        } else {
            this.SelectedWheel = null;
        }
    }

    /*
        Async method has been added to interact from the UI which need to wait for financial provider
    */
    async setSelectedWheelIndex(value) {
        this.SelectedWheelIndex = value;

        await this.updateSingleLineFromFinancialProvider();
    }

    get SelectedWheelIndex() {
        return this._selectedWheelIndex;
    }

    get Accessories() {
        return this._accessories;
    }

    set Accessories(value) {
        this._accessories = value;

        sessionStorage.setItem(Constants.Accessories, JSON.stringify(this._accessories));
    }

    get SelectedAccessories() {
        /*if(!this._selectedAccessories)
            this._selectedAccessories = [];*/
        return this._selectedAccessories;
    }

    async setSelectedAccessories(value) {
        this.SelectedAccessories = value;

        await this.updateSingleLineFromFinancialProvider();
    }

    set SelectedAccessories(value) {
        this._selectedAccessories = value;

        sessionStorage.setItem(Constants.SelectedAccessories, JSON.stringify(value));

        const financial = this.InitialFinancial;
        this.FinancialInfo = this.getFinanceObjectWithCalculations(financial, '', '', false, false, false, false, null, null);

        const gtmHelper = new GTMHelper();
        gtmHelper.setGTM({ 'action': 'Selected Accessories' }, false, false);
    }

    get Categories() {
        return this._categories;
    }

    set Categories(value) {
        this._categories = value;
    }

    get SelectedCategory() {
        return this._selectedCategory;
    }


    async setSelectedCategory(value) {
        this.SelectedCategory = value;
    }

    set SelectedCategory(value) {
        this._selectedCategory = value;
    }

    get TradeInValue() {
        return formatPrice(this._tradeInValue);
    }

    set TradeInValue(value) {
        this._tradeInValue = value !== '' ? parseInt(value.toString().replace('$', '')) : 0;
        sessionStorage.setItem(Constants.TradeInValue, JSON.stringify(this._tradeInValue));
    }


    get DownPaymentValue() {
        return formatPrice(this._downPaymentValue);
    }

    set DownPaymentValue(value) {
        this._downPaymentValue = value !== '' ? parseInt(value.toString().replace('$', '')) : 0;
        sessionStorage.setItem(Constants.DownPaymentValue, JSON.stringify(this._downPaymentValue));
    }


    get LoyaltyChecked() {
        return this._loyaltyChecked;
    }

    set LoyaltyChecked(value) {
        this._loyaltyChecked = value;
        sessionStorage.setItem(Constants.LoyaltyChecked, JSON.stringify(value));
    }

    get GraduateChecked() {
        return this._graduateChecked;
    }

    set GraduateChecked(value) {
        this._graduateChecked = value;
        sessionStorage.setItem(Constants.GraduateChecked, JSON.stringify(value));
    }

    get MilitaryChecked() {
        return this._militaryChecked;
    }

    set MilitaryChecked(value) {
        this._militaryChecked = value;
        sessionStorage.setItem(Constants.MilitaryChecked, JSON.stringify(value));
    }

    get FirstTimeOwnerChecked() {
        return this._firstTimeOwnerChecked;
    }

    set FirstTimeOwnerChecked(value) {
        this._firstTimeOwnerChecked = value;
        sessionStorage.setItem(Constants.FirstTimeOwnerChecked, JSON.stringify(value));
    }    

    get FinanceTermIndex() {
        return this._financeTermIndex;
    }

    set FinanceTermIndex(value) {
        this._financeTermIndex = value;
        sessionStorage.setItem(Constants.FinanceTermIndex, value);
    }

    get FinanceTerm() {
        return this._financeTerm;
    }

    set FinanceTerm(value) {
        if (isNaN(value)) {
            this._financeTerm = null;
            sessionStorage.removeItem(Constants.FinanceTerm);
        } else {
            this._financeTerm = value;
            sessionStorage.setItem(Constants.FinanceTerm, value);
        }
    }

    get LeaseTermIndex() {
        return this._leaseTermIndex;
    }

    set LeaseTermIndex(value) {
        this._leaseTermIndex = value;
        sessionStorage.setItem(Constants.LeaseTermIndex, value);
    }

    get LeaseTerm() {
        return this._leaseTerm;
    }

    set LeaseTerm(value) {
        if (isNaN(value)) {
            this._leaseTerm = null;
            sessionStorage.removeItem(Constants.LeaseTerm);
        } else {
            this._leaseTerm = value;
            sessionStorage.setItem(Constants.LeaseTerm, value);
        }
    }

    get Incentives() {
        return this._incentives;
    }

    set Incentives(value) {
        this._incentives = value;
    }

    get AnnualMileage() {
        return this._annualMileage;
    }

    set AnnualMileage(value) {
        this._annualMileage = value;
        sessionStorage.setItem(Constants.AnnualMileage, value);
    }

    get IncludeFees() {
        return this._includeFees;
    }

    set IncludeFees(value) {
        this._includeFees = value;
        sessionStorage.setItem(Constants.IncludeFees, value);
    }

    get IncludeTaxes() {
        return this._includeTaxes;
    }

    set IncludeTaxes(value) {
        this._includeTaxes = value;
        sessionStorage.setItem(Constants.IncludeTaxes, value);
    }

    get IncludeRebates() {
        return this._includeRebates;
    }

    set IncludeRebates(value) {
        this._includeRebates = value;
        sessionStorage.setItem(Constants.IncludeRebates, value)
    }

    /**
     * Reset
     */
    reset(all = false) {
        this._currentStep = 0;
        const gtmHelper = new GTMHelper();
        if (all) gtmHelper.setGTM({ 'action': 'Reset' }, false, true);
        this._previousStep = 0;

        this._selectedTrim = null;
        this._selectedTrimIndex = 0;

        this._tradeInValue = 0;
        this._downPaymentValue = 0;
        this._loyaltyChecked = false;
        this._militaryChecked = false;
        this._graduateChecked = false;
        this._firstTimeOwnerChecked = true;
        this._accessoriesValue = 0;
        this._annualMileage = 2;

        this._financialInfo = null;
        this._initialFinancial = null;

        this._engineAndDrivetrain = null;
        this._selectedModelIndex = 0;
        this._selectedModel = null;
        this._packages = null;

        this._selectedPackageIndex = null;
        this._selectedNonModelPackageIndex = null;
        this._selectedWarrantyIndex = null;
        this._selectedConnectedVehicleIndex = null;
        this._selectedAddedProtectionIndex= null;
        this._selectedAppearanceProtectionIndex = 0;
        
        this._selectedPackage = {
            financial: {
                msrp: 0
            }
        };
        this._selectedNonModelPackage = {
            financial: {
                msrp: 0
            }
        };
        this._selectedWarrantyPackage = {
            financial: {
                msrp: 0
            }
        };
        this._selectedConnectedVehiclePackage = {
            financial: {
                msrp: 0
            }
        };
        this._selectedAddedProtectionPackage = {
            financial: {
                msrp: 0
            }
        };
        this._selectedAppearanceProtectionPackage = {
            financial: {
                msrp: 0
            }
        };                   

        this._colours = null;
        this._selectedColourInterior = null;
        this._selectedColourInteriorIndex = -1;
        this._selectedColourExterior = null;
        this._selectedColourExteriorIndex = -1;
        this._allowedColoursExterior = [];
        this._wheels = null;
        this._selectedWheel = null;
        this._selectedWheelIndex = null;
        this._accessories = null;
        this._selectedAccessories = [];
        this._categories = null;
        this._selectedCategory = null;

        this._incentives = null;
        this._annualMileage = 2;

        this.IncludeFees = true;

        this.IncludeTaxes = false;

        if(this.isProvinceAllowedToIncludeRebates())
            this.IncludeRebates = true;
        else
            this.IncludeRebates = false;


        this._showFinancePrice = true;

        if (all) {
            this.Current360Rotation = 18;

            this._selectedModelYear = null;
            sessionStorage.removeItem(Constants.SelectedModelYear);

            this._availableTrims = null;
            sessionStorage.removeItem(Constants.AvailableTrim);
            sessionStorage.removeItem(Constants.LegalTrims);

            this._financeTermIndex = 0;
            this._leaseTermIndex = 0;
            sessionStorage.removeItem(Constants.LeaseTermIndex);
            sessionStorage.removeItem(Constants.FinanceTermIndex);

            this._allDataIsLoaded = false;
            sessionStorage.removeItem(Constants.AllDataIsLoaded);

            sessionStorage.removeItem(Constants.SelectedAddedProtectionIndex);
            sessionStorage.removeItem(Constants.SelectedAppearanceProtectionIndex);
            sessionStorage.removeItem(Constants.SelectedAppearanceProtectionPlanPackageIndex);

            this.LeaseTerm = null;
            this.FinanceTerm = null;
            this.AnnualMileage = 2;
        }
        sessionStorage.removeItem(Constants.Colours);
        sessionStorage.removeItem(Constants.CurrentStep);
        sessionStorage.removeItem(Constants.PreviousStep);
        sessionStorage.removeItem(Constants.SelectedExteriorColour);
        sessionStorage.removeItem(Constants.SelectedWheel);
        sessionStorage.removeItem(Constants.SelectedWheelIndex);
        sessionStorage.removeItem(Constants.SelectedModel);
        sessionStorage.removeItem(Constants.FinancialObj);
        sessionStorage.removeItem(Constants.Packages);

        sessionStorage.removeItem(Constants.SelectedPackageIndex);
        sessionStorage.removeItem(Constants.SelectedNonModelPackageIndex);
        sessionStorage.removeItem(Constants.SelectedWarrantyIndex);
        sessionStorage.removeItem(Constants.SelectedConnectedVehicleIndex);
        
        
        sessionStorage.setItem(Constants.SelectedPackage, JSON.stringify(this._selectedPackage));
        sessionStorage.setItem(Constants.SelectedNonModelPackage, JSON.stringify(this._selectedNonModelPackage));
        sessionStorage.setItem(Constants.SelectedWarrantyPackage, JSON.stringify(this._selectedWarrantyPackage));
        sessionStorage.setItem(Constants.SelectedConnectedVehiclePackage, JSON.stringify(this._selectedConnectedVehiclePackage));
        sessionStorage.setItem(Constants.SelectedAddedProtectionPackage, JSON.stringify(this._selectedAddedProtectionPackage));
        sessionStorage.setItem(Constants.SelectedAppearanceProtectionPackage, JSON.stringify(this._selectedAppearanceProtectionPackage));

        sessionStorage.removeItem(Constants.SelectedTrim);
        sessionStorage.removeItem(Constants.SelectedTrimIndex);
        sessionStorage.removeItem(Constants.SelectedInteriorColour);
        sessionStorage.removeItem(Constants.UrlSlugObjectTrims);
        sessionStorage.removeItem(Constants.UrlSlugObjectEngineAndDrivetrain);
        sessionStorage.removeItem(Constants.UrlSlugObjectPackage);
        sessionStorage.removeItem(Constants.UrlSlugObjectColour);
        sessionStorage.removeItem(Constants.UrlSlugObjectWheels);
        sessionStorage.removeItem(Constants.UrlSlugObjectAccessories);
        sessionStorage.removeItem(Constants.UrlSlugObjectPayments);
        sessionStorage.removeItem(Constants.VehicleTitle);
        sessionStorage.removeItem(Constants.SelectedAccessories);
        sessionStorage.removeItem(Constants.TradeInValue);
        sessionStorage.removeItem(Constants.DownPaymentValue);
        sessionStorage.removeItem(Constants.AllowedColoursExterior);
        sessionStorage.removeItem(Constants.LoyaltyChecked);
        sessionStorage.removeItem(Constants.GraduateChecked);
        sessionStorage.removeItem(Constants.MilitaryChecked);
        sessionStorage.removeItem(Constants.FirstTimeOwnerChecked);
        sessionStorage.removeItem(Constants.Accessories);
        sessionStorage.removeItem(Constants.DefaultExteriorColour);
        sessionStorage.removeItem(Constants.DefaultInteriorColour);
        sessionStorage.removeItem(Constants.LegalEngineAndDrivetrain);
        sessionStorage.removeItem(Constants.LegalPackage);
        sessionStorage.removeItem(Constants.LegalColours);
        sessionStorage.removeItem(Constants.LegalWheels);
        sessionStorage.removeItem(Constants.LegalAccessories);
        sessionStorage.removeItem(Constants.LegalPaymentInformation);
        sessionStorage.removeItem(Constants.LegalSummary);
        sessionStorage.removeItem(Constants.EngineAndDrivetrain);
        sessionStorage.removeItem(Constants.SelectedModelIndex);
        sessionStorage.removeItem(Constants.Wheels);
        sessionStorage.removeItem(Constants.SpecificationData);
        sessionStorage.removeItem(Constants.SelectedColourInteriorIndex);
        sessionStorage.removeItem(Constants.SelectedColourExteriorIndex);
        sessionStorage.removeItem(Constants.SelectedVehicle);
        sessionStorage.removeItem(Constants.SelectedWheelSize);
        sessionStorage.removeItem(Constants.InitialFinance);
        sessionStorage.removeItem(Constants.PPSA);
        sessionStorage.setItem(Constants.ShowFinancePrice, JSON.stringify(this._showFinancePrice));
    }

    /**
     * is data loaded
     */
    isDataLoaded() {
        var toReturn = this._selectedTrim && this._selectedPackage && this._colours && this._allowedColoursExterior && this._selectedAccessories && this._financialInfo && this._allDataIsLoaded;
        //console.log("data is loaded", toReturn);
        return toReturn;
    }

    /**
     * validate with the url params and if it's different reset the session storage
     */
    hasParamsDifferentThanCurrentSelection(year, carline, trim, model, option) {
        if (this.SelectedTrim === null || this.SelectedModel === null)
            return true;
        else if (this.SelectedTrim.trim_type.url_slug.toLocaleLowerCase() !== trim.toLocaleLowerCase()) {
            this.reset(false);
            this._allDataIsLoaded = false;
            sessionStorage.setItem(Constants.AllDataIsLoaded, this._allDataIsLoaded);
            sessionStorage.removeItem('province');
            console.log('has reset from different param');
            return true;
        } else if (this.SelectedModel.model_code.toLocaleLowerCase() !== model.toLocaleLowerCase()) {
            this.reset(false);
            this._allDataIsLoaded = false;
            sessionStorage.setItem(Constants.AllDataIsLoaded, this._allDataIsLoaded);
            sessionStorage.removeItem('province');
            console.log('has reset from different param');
            return true;
        }

        return false;
    }

    /**
     * reload stored data
     */
    reloadStoredData() {
        // Fire this first as it might take more time to resolve
        (async() => {
            const isRetailerMode = await this.isRetailerMode();
            //console.log('FINISHED LOADING DATA FOR IS RETAILER MODE', isRetailerMode, this.getDealerVars());
        })();

        if (sessionStorage.getItem(Constants.AllDataIsLoaded)) {
            this._allDataIsLoaded = JSON.parse(sessionStorage.getItem(Constants.AllDataIsLoaded));
        }
        if (sessionStorage.getItem(Constants.SelectedVehicle)) {
            this.selectedVehicle = JSON.parse(sessionStorage.getItem(Constants.SelectedVehicle));
        }
        if (sessionStorage.getItem(Constants.CurrentStep)) {
            this._currentStep = JSON.parse(sessionStorage.getItem(Constants.CurrentStep));
        }
        if (sessionStorage.getItem(Constants.PreviousStep)) {
            this._previousStep = JSON.parse(sessionStorage.getItem(Constants.PreviousStep));
        }
        if (sessionStorage.getItem(Constants.SelectedModelYear)) {
            this._selectedModelYear = JSON.parse(sessionStorage.getItem(Constants.SelectedModelYear));
        }
        if (sessionStorage.getItem(Constants.SelectedTrim)) {
            this._selectedTrim = JSON.parse(sessionStorage.getItem(Constants.SelectedTrim));
        }
        if (sessionStorage.getItem(Constants.SelectedTrimIndex)) {
            this._selectedTrimIndex = parseInt(sessionStorage.getItem(Constants.SelectedTrimIndex));
        }
        if (sessionStorage.getItem(Constants.Packages)) {
            this._packages = JSON.parse(sessionStorage.getItem(Constants.Packages));
        }
        if (sessionStorage.getItem(Constants.SelectedPackage)) {
            this._selectedPackage = JSON.parse(sessionStorage.getItem(Constants.SelectedPackage));
        }
        if (sessionStorage.getItem(Constants.SelectedNonModelPackage)) {
            this._selectedNonModelPackage = JSON.parse(sessionStorage.getItem(Constants.SelectedNonModelPackage));
        }
        if (sessionStorage.getItem(Constants.SelectedWarrantyPackage)) {
            this._selectedWarrantyPackage = JSON.parse(sessionStorage.getItem(Constants.SelectedWarrantyPackage));
        }
        if (sessionStorage.getItem(Constants.SelectedConnectedVehiclePackage)) {
            this._selectedConnectedVehiclePackage = JSON.parse(sessionStorage.getItem(Constants.SelectedConnectedVehiclePackage));
        }
        if (sessionStorage.getItem(Constants.SelectedAddedProtectionPackage)) {
            this._selectedAddedProtectionPackage = JSON.parse(sessionStorage.getItem(Constants.SelectedAddedProtectionPackage));
        }             
        if (sessionStorage.getItem(Constants.SelectedAppearanceProtectionPlansPackage)) {
            this._selectedAppearanceProtectionPackage = JSON.parse(sessionStorage.getItem(Constants.SelectedAppearanceProtectionPlansPackage));
        }

        if (sessionStorage.getItem(Constants.SelectedPackageIndex)) {
            this._selectedPackageIndex = JSON.parse(sessionStorage.getItem(Constants.SelectedPackageIndex));  // Allow null
        }
        if (sessionStorage.getItem(Constants.SelectedNonModelPackageIndex)) {
            this._selectedNonModelPackageIndex = JSON.parse(sessionStorage.getItem(Constants.SelectedNonModelPackageIndex)); // Allow null
        }
        if (sessionStorage.getItem(Constants.SelectedWarrantyIndex)) {
            this._selectedWarrantyIndex = JSON.parse(sessionStorage.getItem(Constants.SelectedWarrantyIndex));  // Allow null
        }
        if (sessionStorage.getItem(Constants.SelectedConnectedVehicleIndex)) {
            this._selectedConnectedVehicleIndex = JSON.parse(sessionStorage.getItem(Constants.SelectedConnectedVehicleIndex)); // Allow null
        }
        if (sessionStorage.getItem(Constants.SelectedAddedProtectionIndex)) {
            this._selectedAddedProtectionIndex = JSON.parse(sessionStorage.getItem(Constants.SelectedAddedProtectionIndex)); // Allow null
        }
        if (sessionStorage.getItem(Constants.SelectedAppearanceProtectionIndex)) {
            this._selectedAppearanceProtectionIndex = JSON.parse(sessionStorage.getItem(Constants.SelectedAppearanceProtectionIndex)); // Allow null
        }        
        if (sessionStorage.getItem(Constants.SelectedAppearanceProtectionPlanPackageIndex)) {
            this._selectedAppearanceProtectionPlanPackageIndex = JSON.parse(sessionStorage.getItem(Constants.SelectedAppearanceProtectionPlanPackageIndex)); // Allow null
        }
        
        if (sessionStorage.getItem(Constants.SelectedWheel)) {
            this._selectedWheel = JSON.parse(sessionStorage.getItem(Constants.SelectedWheel));
        }
        if (sessionStorage.getItem(Constants.SelectedWheelIndex)) {
            this._selectedWheelIndex = parseInt(sessionStorage.getItem(Constants.SelectedWheelIndex));
        }
        if (sessionStorage.getItem(Constants.Wheels)) {
            this._wheels = JSON.parse(sessionStorage.getItem(Constants.Wheels));
        }
        this._engineAndDrivetrain = JSON.parse(sessionStorage.getItem(Constants.EngineAndDrivetrain));
        if (sessionStorage.getItem(Constants.SelectedModel)) {
            this._selectedModel = JSON.parse(sessionStorage.getItem(Constants.SelectedModel));
        }
        if (sessionStorage.getItem(Constants.SelectedModelIndex)) {
            this._selectedModelIndex = parseInt(sessionStorage.getItem(Constants.SelectedModelIndex));
        }
        this._colours = JSON.parse(sessionStorage.getItem(Constants.Colours));
        this._selectedColourExterior = JSON.parse(sessionStorage.getItem(Constants.DefaultExteriorColour));
        this._selectedColourInterior = JSON.parse(sessionStorage.getItem(Constants.DefaultInteriorColour));
        if (sessionStorage.getItem(Constants.SelectedExteriorColour)) {
            this._selectedColourExterior = JSON.parse(sessionStorage.getItem(Constants.SelectedExteriorColour));
        }
        if (sessionStorage.getItem(Constants.SelectedInteriorColour)) {
            this._selectedColourInterior = JSON.parse(sessionStorage.getItem(Constants.SelectedInteriorColour));
        }
        if (sessionStorage.getItem(Constants.AllowedColoursExterior)) {
            this._allowedColoursExterior = JSON.parse(sessionStorage.getItem(Constants.AllowedColoursExterior));
        }
        if (sessionStorage.getItem(Constants.SelectedColourExteriorIndex)) {
            this._selectedColourExteriorIndex = parseInt(sessionStorage.getItem(Constants.SelectedColourExteriorIndex));
        }
        if (sessionStorage.getItem(Constants.SelectedColourInteriorIndex)) {
            this._selectedColourInteriorIndex = parseInt(sessionStorage.getItem(Constants.SelectedColourInteriorIndex));
        }
        if (sessionStorage.getItem(Constants.SelectedAccessories)) {
            this._selectedAccessories = JSON.parse(sessionStorage.getItem(Constants.SelectedAccessories));
        }
        if (sessionStorage.getItem(Constants.InitialFinance)) {
            this._initialFinancial = JSON.parse(sessionStorage.getItem(Constants.InitialFinance));
        }
        if (sessionStorage.getItem(Constants.FinancialObj)) {
            this._financialInfo = JSON.parse(sessionStorage.getItem(Constants.FinancialObj));
        }
        if (sessionStorage.getItem(Constants.LeaseTermIndex)) {
            this._leaseTermIndex = parseInt(sessionStorage.getItem(Constants.LeaseTermIndex));
        }
        if (sessionStorage.getItem(Constants.FinanceTermIndex)) {
            this._financeTermIndex = parseInt(sessionStorage.getItem(Constants.FinanceTermIndex));
        }
        if (sessionStorage.getItem(Constants.LoyaltyChecked)) {
            this._loyaltyChecked = JSON.parse(sessionStorage.getItem(Constants.LoyaltyChecked));
        }
        if (sessionStorage.getItem(Constants.GraduateChecked)) {
            this._graduateChecked = JSON.parse(sessionStorage.getItem(Constants.GraduateChecked));
        }
        if (sessionStorage.getItem(Constants.MilitaryChecked)) {
            this._militaryChecked = JSON.parse(sessionStorage.getItem(Constants.MilitaryChecked));
        }
        if (sessionStorage.getItem(Constants.FirstTimeOwnerChecked)) {
            this._firstTimeOwnerChecked = JSON.parse(sessionStorage.getItem(Constants.FirstTimeOwnerChecked));
        }        
        if (sessionStorage.getItem(Constants.TradeInValue)) {
            this._tradeInValue = JSON.parse(sessionStorage.getItem(Constants.TradeInValue));
        }
        if (sessionStorage.getItem(Constants.DownPaymentValue)) {
            this._downPaymentValue = JSON.parse(sessionStorage.getItem(Constants.DownPaymentValue));
        }
        if (sessionStorage.getItem(Constants.AnnualMileage)) {
            this._annualMileage = parseInt(sessionStorage.getItem(Constants.AnnualMileage));
        }
        if (sessionStorage.getItem(Constants.Accessories)) {
            this._accessories = JSON.parse(sessionStorage.getItem(Constants.Accessories));
        }
        if (sessionStorage.getItem(Constants.IncludeFees)) {
            this._includeFees = JSON.parse(sessionStorage.getItem(Constants.IncludeFees));
        }
        if (sessionStorage.getItem(Constants.IncludeRebates)) {
            this._includeRebates = JSON.parse(sessionStorage.getItem(Constants.IncludeRebates));
        }
        if (sessionStorage.getItem(Constants.IncludeTaxes)) {
            this._includeTaxes = JSON.parse(sessionStorage.getItem(Constants.IncludeTaxes));
        }
        if (sessionStorage.getItem(Constants.AvailableTrim)) {
            this._availableTrims = JSON.parse(sessionStorage.getItem(Constants.AvailableTrim));
        }
        if (sessionStorage.getItem(Constants.FinanceTerm)) {
            this._financeTerm = parseInt(sessionStorage.getItem(Constants.FinanceTerm));
        }
        if (sessionStorage.getItem(Constants.LeaseTerm)) {
            this._leaseTerm = parseInt(sessionStorage.getItem(Constants.LeaseTerm));
        }
        
        this.RecalculateFinancialInfo();
        if (this.FinancialInfo)
            this.Incentives = this.getIncentives(this.FinancialInfo);

        return this;
    }

    /**
     * Set the default trim index to another one. This function has been introduced to hardcode the GS not beeing available on the the CX-90. HARDCODING IS BAD! 
     */
    getDefaultTrimIndex(year, carline, trim, model, packageCode) {
        let defaultTrimIndex = 0;

        if (year === "2024" && (carline === 'CX-90-MHEV' || carline === 'CX-90-PHEV'))
            defaultTrimIndex = 1;

        if (year === "2023" && (carline === 'CX-5'))
            defaultTrimIndex = 1;

        return defaultTrimIndex;
    }

    /**
     * Method that cascade and load all the data
     */
    async loadVehicleData(year, carline, trim, model, packageCode) {
        await this.loadTrims(year, carline);

        const defaultTrimIndex = this.getDefaultTrimIndex(year, carline, trim, model, packageCode);

        if (trim) {
            const trimIndex = this.AvailableTrim.trims.findIndex(x => x.trim_type.url_slug.toLocaleLowerCase() === trim.toLocaleLowerCase());
            await this.setSelectedTrimIndex(trimIndex > -1 ? trimIndex : defaultTrimIndex);
        } else {
            await this.setSelectedTrimIndex(defaultTrimIndex);
        }

        if (model) {
            const modelIndex = this.EngineAndDrivetrain.models.findIndex(x => x.model_code.toLocaleLowerCase() === model.toLocaleLowerCase());
            await this.setSelectedModelIndex(modelIndex > -1 ? modelIndex : 0);
        }

        if (packageCode) {
            const packageIndex = this.Packages.packages.findIndex(x => x.option_code.toLocaleLowerCase() === packageCode.toLocaleLowerCase());
            // HOTFIX! PackageIndex variable need to be null to not force a package selection.
            await this.setSelectedPackageIndex(packageIndex > -1 ? packageIndex : null);
        }
    }

    /**
     * Method that cascade and load all the data by build id.
     */
    async loadVehicleDataByBuildId(buildId) {

        const data = await this._apiService.getBuildDataById(buildId);
        if (data.status === 200 && data.data) {

            const { year, carline, trim, tradeInValue, downPaymentValue, loyaltyChecked, militaryChecked, firstTimeOwnerChecked, graduateChecked, annualMileage, financeTerm, leaseTerm, accessories, modelCode, optionCode, includeTaxes, includeFees, includeRebates, SelectedWheelIndex, SelectedColourExteriorIndex, SelectedColourInteriorIndex, selectedNonModelPackageIndex, selectedWarrantyIndex, selectedConnectedVehicleIndex, selectedAddedProtectionIndex, selectedAppearanceProtectionIndex, selectedAppearanceProtectionPlanPackageIndex } = data.data.build_data;

            this.selectedVehicle.year = year;
            this.selectedVehicle.carline = carline;
            this.selectedVehicle.trim = trim;

            await this.loadVehicleData(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim);

            await this.loadPackages(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim, this.SelectedModel.model_code, this.SelectedModel.option_code);

            // USING PARSE TO FIX THE 'NULL' instead of NULL            
            if (JSON.parse(selectedNonModelPackageIndex))
                this.SelectedNonModelPackageIndex = JSON.parse(selectedNonModelPackageIndex);

            if (selectedWarrantyIndex)
                this.SelectedWarrantyIndex = selectedWarrantyIndex;

            /*if (JSON.parse(selectedConnectedVehicleIndex))
                this.SelectedConnectedVehicleIndex = JSON.parse(selectedConnectedVehicleIndex);

            if (JSON.parse(selectedAddedProtectionIndex))
                this.SelectedAddedProtectionIndex = JSON.parse(selectedAddedProtectionIndex);

            if (JSON.parse(selectedAppearanceProtectionIndex) && JSON.parse(selectedAppearanceProtectionPlanPackageIndex)) {
                this.SelectedAppearanceProtectionIndex = JSON.parse(selectedAppearanceProtectionIndex);
                this.SelectedAppearanceProtectionPlanPackageIndex = JSON.parse(selectedAppearanceProtectionPlanPackageIndex);
            }*/

            await this.loadColours(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim, this.SelectedModel.model_code, this.SelectedModel.option_code);

            this.SelectedColourExteriorIndex = SelectedColourExteriorIndex;
            this.SelectedColourInteriorIndex = SelectedColourInteriorIndex;

            await this.loadWheels(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim, this.SelectedModel.model_code, this.SelectedModel.option_code);

            if (SelectedWheelIndex) this.SelectedWheelIndex = SelectedWheelIndex;

            await this.loadAccessories(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim, this.SelectedModel.model_code, this.SelectedModel.option_code);

            const accessoriesData = await this._apiService.getAccessories(modelCode, optionCode);
            if (accessoriesData.accessories && accessories && accessories.length > 0) {
                const parsed = this.parseAccessoriesData(accessoriesData.accessories.accessories);
                if (parsed && parsed.All) {
                    this.SelectedAccessories = parsed.All.filter(acc => accessories.includes(acc.part_number));
                }
            }

            this.FinancialInfo = await this.getFinanceObjectWithCalculations(
                this.FinancialInfo, this.TradeInValue, this.DownPaymentValue,
                this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, 
                this.FinanceTermIndex, this.LeaseTermIndex, annualMileage
            );

            this.TradeInValue = tradeInValue;
            this.DownPaymentValue = downPaymentValue;
            this.LoyaltyChecked = loyaltyChecked;
            this.GraduateChecked = graduateChecked;
            this.MilitaryChecked = militaryChecked;
            this.FirstTimeOwnerChecked = firstTimeOwnerChecked;
            this.FinanceTermIndex = financeTerm;
            this.LeaseTermIndex = leaseTerm;
            if (annualMileage) this.AnnualMileage = annualMileage;
            if (includeTaxes) this.IncludeTaxes = includeTaxes;
            if (includeFees) this.IncludeFees = includeFees;
            if (includeRebates) this.IncludeRebates = includeRebates;

            await this.loadPayments(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim, this.SelectedModel.model_code, this.SelectedModel.option_code);

            await this.updateSingleLineFromFinancialProvider();

            return data.data.build_data;
        } else {
            console.log('Error: ', data.msg)
        }
    }

    /**
     * Presentation page - Select a vehicles
     */
    loadVehicles() {
        return new Promise((resolve, reject) => {
            if (window.bnp_under_maintenance) {
                if (getLang() === "en") {
                    const mock = require('../Services/vehiclesMockEn.json');
                    resolve(mock.data);
                } else {
                    const mock = require('../Services/vehiclesMockFr.json');
                    resolve(mock.data);
                }
            } else {
                this._apiService.getVehicles()
                    .then((data) => {
                        resolve(data);
                    }).catch(error => {
                        console.log(error);
                        reject(error);
                    });
            }
        });
    }

    /**
     * Load Step 1 - Select a trim
     */
    async loadTrims(year, carline) {
        this.selectedVehicle.year = year;
        this.selectedVehicle.carline = carline;
        sessionStorage.setItem(Constants.SelectedVehicle, JSON.stringify(this.selectedVehicle));

        const trimData = await this._apiService.getTrims(this.selectedVehicle.year, this.selectedVehicle.carline);

        // Added this patch to redirect to vehicle landing page when we don't receive any trim data array
        if (!trimData || trimData.length === 0) {
            if (this.language === 'fr')
                window.location = '/fr/magasiner/construction-et-prix/';
            else
                window.location = '/en/shopping/build-and-price/';
        }

        this.SelectedModelYear = trimData.model_year;

        this.AvailableTrim = trimData;
    }

    /**
     * Load Step 2 - Select an engine and drivetrain
     */
    async loadEngineAndDrivetrain(year, carline, trim) {
        this.selectedVehicle.year = year;
        this.selectedVehicle.carline = carline;
        this.selectedVehicle.trim = trim;
        sessionStorage.setItem(Constants.SelectedVehicle, JSON.stringify(this.selectedVehicle));

        const data = await this._apiService.getEngineAndDrivetrain(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim);

        this.EngineAndDrivetrain = data;

        sessionStorage.setItem(Constants.UrlSlugObjectEngineAndDrivetrain, JSON.stringify({ 'year': year, 'carline': carline, 'trim': trim }));
    }

    /**
     * Load Step 3 - Select a package
     */
    async loadPackages(year, carline, trim, model, packageCode) {
        this.selectedVehicle.year = year;
        this.selectedVehicle.carline = carline;
        this.selectedVehicle.trim = trim;
        this.selectedVehicle.model = model;
        this.selectedVehicle.packageCode = packageCode;
        sessionStorage.setItem(Constants.SelectedVehicle, JSON.stringify(this.selectedVehicle));

        const data = await this._apiService.getPackages(this.selectedVehicle.model, this.selectedVehicle.packageCode);

        this.Packages = data;
        this.SelectedPackageIndex = null;
        this.SelectedNonModelPackageIndex = null;
        this.SelectedConnectedVehicleIndex = null;
        this.SelectedWarrantyIndex = null;

        sessionStorage.setItem(Constants.UrlSlugObjectPackage, JSON.stringify({ 'year': year, 'carline': carline, 'trim': trim, 'model': model, 'packageCode': packageCode }));
    }

    getAllowedExteriorsIds(exteriors) {
        let allowedExteriors = [];
        exteriors.forEach(exterior => {
            allowedExteriors.push(exterior.id);
        });
        return allowedExteriors;
    }

    /**
     * Load Step 4 - Select the exterior and interior color
     */
    async loadColours(year, carline, trim, model, packageCode) {
        this.selectedVehicle.year = year;
        this.selectedVehicle.carline = carline;
        this.selectedVehicle.trim = trim;
        this.selectedVehicle.model = model;
        this.selectedVehicle.packageCode = packageCode;
        sessionStorage.setItem(Constants.SelectedVehicle, JSON.stringify(this.selectedVehicle));

        const data = await this._apiService.getColours(this.selectedVehicle.model, this.selectedVehicle.packageCode)

        this.InitialFinancial = data.financial;
        this.Incentives = this.getIncentives(this.InitialFinancial);
        this.Colours = data;
        sessionStorage.setItem(Constants.UrlSlugObjectColour, JSON.stringify({ 'year': year, 'carline': carline, 'trim': trim, 'model': model, 'packageCode': packageCode }));

        const defaultInteriorColour = this.Colours.visual.interiors[0];
        const defaultExteriorColour = defaultInteriorColour.default_exterior;
        sessionStorage.setItem(Constants.DefaultInteriorColour, JSON.stringify(defaultInteriorColour));
        sessionStorage.setItem(Constants.DefaultExteriorColour, JSON.stringify(defaultExteriorColour));

        this.Colours.visual.interiors.map((Colour, index) => {
            if (defaultInteriorColour.id === Colour.id)
                this.SelectedColourInteriorIndex = index;
        });

        Object.entries(this.Colours.visual.exteriors).map((Colour, index) => {
            if (defaultExteriorColour.id === Colour[1]['id'])
                this.SelectedColourExteriorIndex = index;
        });

        this.AllowedColoursExterior = this.getAllowedExteriorsIds(this.Colours.visual.interiors[this.SelectedColourInteriorIndex].allowed_exteriors);
    }

    /**
     * Load Step 5 - Select a wheel
     */
    async loadWheels(year, carline, trim, model, packageCode) {
        this.selectedVehicle.year = year;
        this.selectedVehicle.carline = carline;
        this.selectedVehicle.trim = trim;
        this.selectedVehicle.model = model;
        this.selectedVehicle.packageCode = packageCode;
        sessionStorage.setItem(Constants.SelectedVehicle, JSON.stringify(this.selectedVehicle));

        const data = await this._apiService.getWheels(model, packageCode);
        //console.log(data);

        this.InitialFinancial = data.financial;
        this.Wheels = data;
        sessionStorage.setItem(Constants.UrlSlugObjectWheels, JSON.stringify({ 'year': year, 'carline': carline, 'trim': trim, 'model': model, 'packageCode': packageCode }));
    }

    /**
     * Load Step 6 - Select one or many accessory
     */
    async loadAccessories(year, carline, trim, model, packageCode) {
        this.selectedVehicle.year = year;
        this.selectedVehicle.carline = carline;
        this.selectedVehicle.trim = trim;
        this.selectedVehicle.model = model;
        this.selectedVehicle.packageCode = packageCode;
        sessionStorage.setItem(Constants.SelectedVehicle, JSON.stringify(this.selectedVehicle));

        const data = await this._apiService.getAccessories(model, packageCode);

        this.InitialFinancial = data.financial;

        this.FinancialInfo = this.getFinanceObjectWithCalculations(data.financial, '', '', false, false, false, false, null, null);
        this.Accessories = {
            'data': this.parseAccessoriesData(data.accessories.accessories),
            'title': data.title,
            'rawData': Object.entries(data.accessories.accessories)
        };
        sessionStorage.setItem(Constants.UrlSlugObjectAccessories, JSON.stringify({ 'year': year, 'carline': carline, 'trim': trim, 'model': model, 'packageCode': packageCode }));
    }

    /**
     * Load Step 7 - Payment information
     */
    async loadPayments(year, carline, trim, model, packageCode) {
        this.selectedVehicle.year = year;
        this.selectedVehicle.carline = carline;
        this.selectedVehicle.trim = trim;
        this.selectedVehicle.model = model;
        this.selectedVehicle.packageCode = packageCode;
        sessionStorage.setItem(Constants.SelectedVehicle, JSON.stringify(this.selectedVehicle));

        // Preload missing data to set the payment
        if (!this.InitialFinancial) {
            await this.loadColours(this.selectedVehicle.year, this.selectedVehicle.carline, this.selectedVehicle.trim, this.selectedVehicle.model, this.selectedVehicle.packageCode);
        }

        const data = await this._apiService.getPayments(model, packageCode);

        const financial = this.InitialFinancial;
        this.FinancialInfo = this.getFinanceObjectWithCalculations(financial, '', '', false, false, false, false, null, null);
        sessionStorage.setItem(Constants.UrlSlugObjectPayments, JSON.stringify({ 'year': year, 'carline': carline, 'trim': trim, 'model': model, 'packageCode': packageCode }));

        // Reset the value
        if(getParams()['tve'] === undefined){
            this.TradeInValue = 0;
        } else {
            this.TradeInValue = getParams()['tve'][0];
        }

        this.DownPaymentValue = 0;
        this.LoyaltyChecked = false;
        this.GraduateChecked = false;
        this.MilitaryChecked = false;

        // SET DEFAULT VALUE for first time owner when it has a value.  Part of a campaign
        this.FirstTimeOwnerChecked = false; //this.FinancialInfo.incentive_programs.find(x => x.type === "first_time_owner").value;



        // Make sure that we have a lease term index value or we set the highest one
        if (this.LeaseTerm) {
            let foundIndex = this.FinancialInfo.lease.findIndex(x => x.term === this.LeaseTerm);

            if (foundIndex > -1)
                this.LeaseTermIndex = foundIndex;
            else
                this.LeaseTermIndex = this.FinancialInfo.lease.length - 1;

        } else {
            // HARDCODED RULES ADDED FOR QUEBEC
            if (carline === 'CX-90-PHEV' && getProvince() === 'QC') {
                this.LeaseTermIndex = this.FinancialInfo.lease.findIndex(x => x.term === 36);
            } else {
                this.LeaseTermIndex = this.FinancialInfo.lease.length - 1;
            }
        }

        if (this.FinanceTerm) {
            let foundIndex = this.FinancialInfo.apr.findIndex(x => x.term === this.FinanceTerm);
            if (foundIndex > -1)
                this.FinanceTermIndex = foundIndex;
            else
                this.FinanceTermIndex = this.FinancialInfo.apr.length - 1;
        } else {
            this.FinanceTermIndex = this.FinancialInfo.apr.length - 1;
        }

        this.Incentives = this.getIncentives(this.FinancialInfo);
    }

    /**
     * Load Step 8 - Load the summary. This function should be sooner or later deprecated because we have thw hole object
     */
    async loadSummary(year, carline, trim, model, packageCode) {
        this.selectedVehicle.year = year;
        this.selectedVehicle.carline = carline;
        this.selectedVehicle.trim = trim;
        this.selectedVehicle.model = model;
        this.selectedVehicle.packageCode = packageCode;
        sessionStorage.setItem(Constants.SelectedVehicle, JSON.stringify(this.selectedVehicle));

        const data = await this._apiService.getSummary(model, packageCode);
        
        // Set new legal
        sessionStorage.setItem(Constants.LegalTrims, JSON.stringify(buildLegalContent(data.trims, data.incentives)));
        sessionStorage.setItem(Constants.LegalOption, JSON.stringify(buildLegalContent(data.options, data.incentives)));
        sessionStorage.setItem(Constants.LegalColours, JSON.stringify(buildLegalContent(data.colours, data.incentives)));
        sessionStorage.setItem(Constants.LegalWheels, JSON.stringify(buildLegalContent(data.wheels, data.incentives)));
        sessionStorage.setItem(Constants.LegalConnectivity, JSON.stringify(buildLegalContent(data.connectivity, data.incentives)));
        sessionStorage.setItem(Constants.LegalAccessories, JSON.stringify(buildLegalContent(data.accessories, data.incentives)));        
        sessionStorage.setItem(Constants.LegalProtections, JSON.stringify(buildLegalContent(data.protection, data.incentives)));
        sessionStorage.setItem(Constants.LegalPaymentInformation, JSON.stringify(buildLegalContent(data.payments, data.incentives)));
        sessionStorage.setItem(Constants.LegalSummary, JSON.stringify(buildLegalContent(data.summary)));
                
        this.reloadStoredData();
    }

    /**
     * Load Step 8 - Load the summary. This function should be sooner or later deprecated because we have thw hole object
     */
    async loadVehiclesLegal(modelCode, packageCode) {
        if (window.bnp_under_maintenance) {
            if (getLang() === "en") {
                const mock = require('../Services/vehiclesLegalMockEn.json');
                return mock.data.vehicles;
            } else {
                const mock = require('../Services/vehiclesLegalMockFr.json');
                return mock.data.vehicles;
            }
        } else {
            // HARDCODING MODEL AND PACKAGE CODE AS IT DOESN'T MATTER FOR THE VEHICLE LANDING PAGE LEGAL
            const data = await this._apiService.getSummary(modelCode, packageCode);

            // Set new legal
            sessionStorage.setItem(Constants.LegalVehicles, JSON.stringify(buildLegalContent(data.vehicles)));

            return data.vehicles;
        }
    }    

    async loadSpecsData(model, packageCode) {
        const data = await this._apiService.getSpecificationsData(model, packageCode);

        sessionStorage.setItem(Constants.SpecificationData, JSON.stringify(data[0].specifications));
    }

    hasDefaultInteriorColorSelected() {
        let hasDefaultInteriorColorSelected = false;

        const selectedInteriorColour = JSON.parse(sessionStorage.getItem(Constants.SelectedInteriorColour));
        if (this.Colours && selectedInteriorColour) {
            // Look if the interior colour isn't a default selection
            const defaultInteriorColour = this.Colours.visual.interiors[0];
            if (defaultInteriorColour.id === selectedInteriorColour.id)
                hasDefaultInteriorColorSelected = true;
        }

        return hasDefaultInteriorColorSelected;
    }

    hasDefaultExteriorColorSelected() {
        let hasDefaultExteriorColorSelected = false;

        const selectedExteriorColour = JSON.parse(sessionStorage.getItem(Constants.SelectedExteriorColour));
        if (this.Colours && selectedExteriorColour) {
            const defaultInteriorColour = this.Colours.visual.interiors[0];
            const defaultExteriorColour = defaultInteriorColour.default_exterior;
            if (defaultExteriorColour.id === selectedExteriorColour.id)
                hasDefaultExteriorColorSelected = true;
        }

        return hasDefaultExteriorColorSelected;
    }

    displayWarning() {
        let showWarningMessage = false;

        switch (this.CurrentStep) {
            case 1: // TRIM
            case 2: // ENGINE AND DRIVETRAIN
                if (this.SelectedPackageIndex != null || this.SelectedNonModelPackageIndex != null || this.SelectedWarrantyIndex != null || this.SelectedConnectedVehicleIndex != null)
                    showWarningMessage = true;

                if (this.hasDefaultExteriorColorSelected() && this.hasDefaultInteriorColorSelected()) {
                    // console.log('no default color selected');
                } else {
                    showWarningMessage = true;
                }

                if (this.SelectedAccessories && this.SelectedAccessories.length > 0)
                    showWarningMessage = true;

                if (this.SelectedWheel)
                    showWarningMessage = true;
                break;
            case 3: // PACKAGES
            case 4: // COLORS
            case 5: // WHEELS:
            case 6: // ACCESSORIES
            default:
                showWarningMessage = false;
        }

        // if (this._selectedModelIndex > 0 || this._selectedPackageIndex != null || this.SelectedNonModelPackageIndex != null|| this._selectedColourExteriorIndex > 0 || this._selectedColourInteriorIndex > 0)
        //     showWarningMessage = true;

        return showWarningMessage;
    }


    // todo move to utility class
    groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key].title] = rv[x[key].title] || []).push(x);
            return rv;
        }, {});
    };

    get VehicleTitle() {
        let title;
        let plainTitle;
        let mazda = '';
        const yearName = this.EngineAndDrivetrain ?.model_year ?.year ?.title;
        const modelName = this.EngineAndDrivetrain ?.model_year ?.carline ?.title;
        const trimName = this.EngineAndDrivetrain ?.trim ?.trim_type ?.name
        switch (this.CurrentStep) {
            case 7: // payment
            case 1: // trim
            case 2: // engine & drivetrain
            case 3: // packages
            case 4: // colours
            case 5: // wheels
            case 6: // accessories
            default:
                let sup = '';
                if (modelName ?.includes('CX-90') && trimName == 'GS' && yearName === '2024') {
                    sup = '<sup>✦</sup>';
                }
                if (modelName ?.includes('Mazda CX-50 Hybrid') && trimName == 'GS-L' && yearName === '2025') {
                    sup = '<sup>†</sup>';
                }                

                if (title && !(modelName.toUpperCase().includes("MAZDA")))
                    mazda = 'MAZDA';
                if (this._language === "en") {
                    title = `${yearName} ${mazda} ${modelName} ${trimName}${sup} `;

                } else { // assume that it's french
                    if (modelName === undefined) {
                        title = ``;
                    } else {
                        title = `${mazda} ${modelName} ${trimName} ${yearName}${sup}`; //this.EngineAndDrivetrain?.trim?.title;
                        //plainTitle = `${mazda} ${modelName} ${trimName} ${yearName}`;
                        plainTitle = `${modelName}`;
                    }
                }
                // set title without any other bells and whistles
                plainTitle = `${modelName}`;
                sessionStorage.setItem('plainTitle', plainTitle.replace(new RegExp('mazda ', 'ig'), ''));
                break;
        }

        if (!title)
            title = sessionStorage.getItem(Constants.VehicleTitle); // Hack for not showing undefined when switching trim
        if (title !== '' && (title === null || title.includes('undefined')))
            return '';
        else
            return title;
    }

    /**
     * Recalculate the object FinancialInfo used at many place
     */
    async RecalculateFinancialInfo() {
        await this.loadFromFinancialProvider();

        if (this.FinancialInfo) {
            this.FinancialInfo = this.getFinanceObjectWithCalculations(this.FinancialInfo, this._tradeInValue, this._downPaymentValue, this.LoyaltyChecked, this.GraduateChecked, this.MilitaryChecked, this.FirstTimeOwnerChecked, this.FinanceTermIndex, this.LeaseTermIndex, this.AnnualMileage);
        }
        return this.FinancialInfo;
    }

    /**
     * getFinanceObjectWithCalculations
     */
    getFinanceObjectWithCalculations(financialObj, tradeInValue, downPaymentValue, loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked, financeTermIndex, leaseTermIndex, annualMileage) {
        // Save the financial object initial states in storage for later fetching PPSA
        sessionStorage.setItem(Constants.FinancialObj, JSON.stringify(financialObj));        

        let accessories = 0;
        if (typeof annualMileage === "undefined") {
            annualMileage = 0;
        } else {
            annualMileage = parseInt(annualMileage);
        }
        if (!tradeInValue) tradeInValue = '0';
        tradeInValue = tradeInValue !== '' ? parseInt(tradeInValue.toString().replace('$', '')) : 0;
        if (!downPaymentValue) downPaymentValue = '0';
        downPaymentValue = downPaymentValue !== '' ? parseInt(downPaymentValue.toString().replace('$', '')) : 0;

        financialObj.tradeInValue = parseInt(tradeInValue);
        financialObj.downPaymentValue = parseInt(downPaymentValue);
        financialObj.loyaltyChecked = loyaltyChecked;
        financialObj.militaryChecked = militaryChecked;
        financialObj.graduateChecked = graduateChecked;
        financialObj.firstTimeOwnerChecked = firstTimeOwnerChecked;
        financialObj.accessoriesValue = accessories;
        financialObj.annualMileage = annualMileage;
        financialObj.financeTerm = financeTermIndex !== null ? financeTermIndex : financialObj.apr.length - 1;
        financialObj.leaseTerm = leaseTermIndex !== null ? leaseTermIndex : financialObj.lease.length - 1;
        financialObj.incentive_programs = financialObj.incentive_programs ? financialObj.incentive_programs : [];
        financialObj.package = this.SelectedPackage;
        financialObj.warranty = this.SelectedWarrantyPackage;
        financialObj.connectedVehicle = this.SelectedConnectedVehiclePackage;
        financialObj.addedProtection = this.SelectedAddedProtectionPackage;
        financialObj.appearanceProtection = this.SelectedAppearanceProtectionPlansPackage;
        
        
        // FEES EXTRACTION

        financialObj.freight = financialObj.fees.filter((fee) => fee.title === 'Freight').length ? financialObj.fees.filter((fee) => fee.title === 'Freight')[0].price : 0;
        financialObj.pde = financialObj.fees.filter((fee) => fee.title === 'PDE').length ? financialObj.fees.filter((fee) => fee.title === 'PDE')[0].price : 0;
        financialObj.acTax = financialObj.fees.filter((fee) => fee.title === 'A/C Tax').length ? financialObj.fees.filter((fee) => fee.title === 'A/C Tax')[0].price : 0;
        financialObj.exciseTax = financialObj.fees.filter((fee) => fee.title === 'Federal Excise Tax').length ? financialObj.fees.filter((fee) => fee.title === 'Federal Excise Tax')[0].price : 0;
        financialObj.amvic = financialObj.fees.filter((fee) => fee.title === 'AMVIC').length ? financialObj.fees.filter((fee) => fee.title === 'AMVIC')[0].price : 0;
        financialObj.omvic = financialObj.fees.filter((fee) => fee.title === 'OMVIC').length ? financialObj.fees.filter((fee) => fee.title === 'OMVIC')[0].price : 0;
        financialObj.tireStewardshipFee = financialObj.fees.filter((fee) => fee.title === 'Tire Shewardship Fee').length ? financialObj.fees.filter((fee) => fee.title === 'Tire Shewardship Fee')[0].price : 0;
        financialObj.oil = financialObj.fees.filter((fee) => fee.title === 'Oil').length ? financialObj.fees.filter((fee) => fee.title === 'Oil')[0].price : 0;

        // LEASE AND ADMIN SERVICE FEES ARE THE SAME STARTING 1ST JANUARY 2024 // 595
        financialObj.leaseServiceFees = financialObj.fees.filter((fee) => fee.title === 'Administration Fee').length ? financialObj.fees.filter((fee) => fee.title === 'Administration Fee')[0].price : 0;
        financialObj.adminServiceFees = financialObj.fees.filter((fee) => fee.title === 'Administration Fee').length ? financialObj.fees.filter((fee) => fee.title === 'Administration Fee')[0].price : 0;

        financialObj.mazdaCashIncentive = financialObj.incentive_programs.filter((fee) => fee.type === 'mazda_retail_cash').length ? financialObj.incentive_programs.filter((fee) => fee.type === 'mazda_retail_cash')[0].value : 0;

        financialObj.calculatedCash = this.cashCalculator(financialObj, tradeInValue, downPaymentValue, loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked);
        financialObj.calculatedFinance = this.loanCalculator(financialObj, tradeInValue, downPaymentValue, loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked);
        financialObj.calculatedLease = this.leaseCalculator(financialObj, tradeInValue, downPaymentValue, loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked, annualMileage);
       
        financialObj.minDownPayment = 0;
        financialObj.maxDownPayment = this.getMaxDownPayment(financialObj);
        sessionStorage.setItem(Constants.FinancialObj, JSON.stringify(financialObj));

        return financialObj;
    }

    /**
     * cashCalculator
     */
    cashCalculator(financialObj, tradeInValue, downPaymentValue, loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked) {
        let tempIncentives = financialObj.incentive_programs.find(element => element.type === "incentive");

        const cashObj = {};
        cashObj.tax = this.getTax();
        cashObj.accessories = this.getAccessories();
        cashObj.options = this.getOptions();
        cashObj.feesAndLevies = this.getFeesAndLeaves(true, false);
        cashObj.incentives = this.getIncentivesObj(loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked, true);
        cashObj.mazdaRetailCash = this.getIncentives(financialObj) ?.mazda_retail_cash ?.value || 0;
        cashObj.specialIncentives = tempIncentives ? tempIncentives.value != null ? tempIncentives.value : 0 : 0;

        cashObj.evRebates = this.getEvRebate(financialObj);
        cashObj.tradeInValue = parseInt(tradeInValue);
        cashObj.downPaymentValue = parseInt(downPaymentValue);

        cashObj.mazdaPrice = financialObj.msrp + 
        /*financialObj.package.financial.msrp + 
        //financialObj.connectedVehicle.financial.msrp + 
        /*financialObj.warranty.financial.msrp +  */
        //financialObj.addedProtection.financial.msrp + 
        //financialObj.appearanceProtection.financial.msrp +
        cashObj.options.displayedTotal + 
        //cashObj.accessories.total + 
        financialObj.freight +
        financialObj.pde +
        financialObj.adminServiceFees;

        const nonTaxableInc = cashObj.incentives.nonTaxable.total + financialObj.mazdaCashIncentive;
        const taxableInc = cashObj.incentives.taxable.total;
        const evRebate = cashObj.evRebates.total.cash;

        const subTotal = financialObj.msrp 
        + cashObj.options.total 
        + cashObj.accessories.total 
        - cashObj.tradeInValue 
        - cashObj.downPaymentValue 
        - cashObj.specialIncentives 
        - taxableInc 
        + financialObj.freight 
        + financialObj.pde
        + financialObj.adminServiceFees;
        cashObj.subtotal = subTotal - nonTaxableInc;
        cashObj.subtotalTaxed = subTotal + (subTotal * cashObj.tax) - nonTaxableInc;
        cashObj.subtotalTaxes = subTotal * cashObj.tax;

        const subtotalFees = subTotal;
        cashObj.subtotalWithFees = subtotalFees - nonTaxableInc + cashObj.feesAndLevies.total;
        cashObj.subtotalWithFeesTaxed = subtotalFees + (subtotalFees * cashObj.tax) - nonTaxableInc + cashObj.feesAndLevies.total;
        cashObj.subtotalWithFeesTaxes = subtotalFees * cashObj.tax;

        const incentiveRebates = subTotal;
        cashObj.subtotalWithIncentiveRebates = incentiveRebates - nonTaxableInc;
        cashObj.subtotalWithIncentiveRebatesAndEvRebates = incentiveRebates - evRebate - nonTaxableInc;
        cashObj.subtotalWithIncentiveRebatesAndEvRebatesTaxed = incentiveRebates + (incentiveRebates * cashObj.tax) - evRebate - nonTaxableInc;
        cashObj.subtotalWithIncentiveRebatesAndEvRebatesTaxes = incentiveRebates * cashObj.tax;

        const feesRebates = subTotal;
        cashObj.subtotalWithFeesWithRebates = feesRebates - nonTaxableInc;
        cashObj.subtotalWithFeesWithRebatesAndEvRebates = feesRebates - nonTaxableInc - evRebate +cashObj.feesAndLevies.total;
        cashObj.subtotalWithFeesWithRebatesTaxed = feesRebates + (feesRebates * cashObj.tax) - evRebate - nonTaxableInc + cashObj.feesAndLevies.total;
        cashObj.subtotalWithFeesWithRebatesTaxes = feesRebates * cashObj.tax;

        return cashObj;
    }

    /**
     * leaseCalculator
     */
    leaseCalculator(financialObj, tradeInValue, downPaymentValue, loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked, annualMileage) {
        let tempIncentives = financialObj.incentive_programs.find(element => element.type === "incentive");

        const leaseObj = {};
        leaseObj.tax = this.getTax();
        leaseObj.accessories = this.getAccessories();
        leaseObj.options = this.getOptions();
        leaseObj.feesAndLevies = this.getFeesAndLeaves(true, true);
        leaseObj.incentives = this.getIncentivesObj(loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked);
        leaseObj.rewards = this.getRewardsList(loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked);
        leaseObj.mazdaRetailCash = this.getIncentives(financialObj)?.mazda_retail_cash?.value || 0;
        leaseObj.specialIncentives = tempIncentives ? tempIncentives.value != null ? tempIncentives.value : 0 : 0;

        leaseObj.evRebates = this.getEvRebate(financialObj);
        leaseObj.tradeInValue = parseInt(tradeInValue);
        leaseObj.downPaymentValue = parseInt(downPaymentValue);
        leaseObj.downPaymentTax = leaseObj.downPaymentValue * leaseObj.tax;
        leaseObj.kilometersLeaseValue = annualMileage;
        
        if (!financialObj.calculatedLease || !financialObj.calculatedLease.leaseValues)
            leaseObj.leaseValues = [...financialObj.lease];
        else
            leaseObj.leaseValues = financialObj.calculatedLease.leaseValues;

        leaseObj.subtotal = financialObj.msrp
            + financialObj.addedProtection.financial.msrp 
            + financialObj.appearanceProtection.financial.msrp
            + financialObj.warranty.financial.msrp
            + financialObj.connectedVehicle.financial.msrp
            + leaseObj.options.total
            + leaseObj.accessories.total
            - leaseObj.tradeInValue
            - leaseObj.specialIncentives
            - leaseObj.incentives.taxable.total
            + leaseObj.leaseValues[this.LeaseTermIndex].ppsa
            + financialObj.freight
            + financialObj.pde;
            

            //total.federal_tax
        //leaseObj.subtotalTaxed = leaseObj.subtotal + (leaseObj.subtotal * leaseObj.tax);
        leaseObj.subtotalWithFees = leaseObj.subtotal + leaseObj.feesAndLevies.total + financialObj.adminServiceFees;
        leaseObj.subtotalWithFeesTaxed = leaseObj.subtotalWithFees + (leaseObj.subtotalWithFees * leaseObj.tax);
        leaseObj.subtotalWithRebates = leaseObj.subtotal - leaseObj.incentives.taxable.total - (leaseObj?.evRebates?.total?.lease ?? 0);
        leaseObj.subtotalWithRebatesTaxed = leaseObj.subtotalWithRebates + (leaseObj.subtotalWithRebates * leaseObj.tax);
        leaseObj.subtotalWithFeesWithRebates = leaseObj.subtotal + leaseObj.feesAndLevies.total + financialObj.adminServiceFees - leaseObj.incentives.taxable.total - (leaseObj?.evRebates?.total?.lease ?? 0);
        leaseObj.subtotalWithFeesWithRebatesTaxed = leaseObj.subtotalWithFeesWithRebates + (leaseObj.subtotalWithFeesWithRebates * leaseObj.tax);

        leaseObj.balanceToLease = leaseObj.subtotal - leaseObj.incentives.nonTaxable.total - leaseObj.downPaymentValue;
        //leaseObj.balanceToLeaseTaxed = leaseObj.subtotalTaxed - leaseObj.incentives.nonTaxable.total - leaseObj.downPaymentValue;
        leaseObj.balanceToLeaseWithFees = leaseObj.subtotalWithFees - leaseObj.incentives.nonTaxable.total - leaseObj.downPaymentValue;
        //leaseObj.balanceToLeaseWithFeesTaxed = leaseObj.subtotalWithFeesTaxed - leaseObj.incentives.nonTaxable.total - leaseObj.downPaymentValue;
        leaseObj.balanceToLeaseWithRebates = leaseObj.subtotalWithRebates - leaseObj.incentives.nonTaxable.total - leaseObj.downPaymentValue;
        //leaseObj.balanceToLeaseWithRebatesTaxed = leaseObj.subtotalWithRebatesTaxed - leaseObj.incentives.nonTaxable.total - leaseObj.downPaymentValue;+
        leaseObj.balanceToLeaseWithFeesWithRebates = leaseObj.subtotalWithFeesWithRebates - leaseObj.incentives.nonTaxable.total - leaseObj.downPaymentValue;

        // Used in the price bar
        leaseObj.balanceToLeaseWithFeesWithRebatesTaxed = leaseObj.subtotalWithFeesWithRebatesTaxed - leaseObj.incentives.nonTaxable.total - leaseObj.downPaymentValue;


        leaseObj.leaseValues.forEach(leaseElement => {
            leaseElement.residual = financialObj.residual.filter((resudualObj) => resudualObj.term === leaseElement.term)[0].rate;
            
            leaseElement.moneyFactor = financialObj.money_factor.filter((moneyFactorObj) => moneyFactorObj.term === leaseElement.term)[0].rate;
            leaseElement.leaseEndValueNoFees = leaseElement.residualAmount;
            leaseElement.leaseEndValue = leaseElement.residualAmount;
        });

        return leaseObj;
    }

    /**
     * loanCalculator
     */
    loanCalculator(financialObj, tradeInValue, downPaymentValue, loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked) {
        let tempIncentives = financialObj.incentive_programs.find(element => element.type === "incentive");

        const financeObj = {};
        financeObj.tax = this.getTax();
        financeObj.accessories = this.getAccessories();
        financeObj.options = this.getOptions();
        financeObj.feesAndLevies = this.getFeesAndLeaves(true, false);
        financeObj.incentives = this.getIncentivesObj(loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked);
        financeObj.evRebates = this.getEvRebate(financialObj);
        financeObj.rewards = this.getRewardsList(loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked);
        financeObj.mazdaRetailCash = this.getIncentives(financialObj)?.mazda_retail_cash?.value || 0;
        financeObj.specialIncentives = tempIncentives ? tempIncentives.value != null ? tempIncentives.value : 0 : 0;
        financeObj.tradeInValue = parseInt(tradeInValue);
        financeObj.downPaymentValue = parseInt(downPaymentValue);

        if (!financialObj.calculatedFinance || !financialObj.calculatedFinance.financeValues)
            financeObj.financeValues = [...financialObj.apr];
        else
            financeObj.financeValues = financialObj.calculatedFinance.financeValues;

        // Do not remove this line below, used in Financial Provider!!!
        financeObj.subtotalWithoutTradInAndDownPayment = financialObj.msrp + financialObj.package.financial.msrp + financialObj.warranty.financial.msrp + financialObj.connectedVehicle.financial.msrp + financeObj.options.total + financeObj.accessories.total;

        financeObj.subtotal = financialObj.msrp 
        /*+ financialObj.package.financial.msrp **/ 
        + financialObj.addedProtection.financial.msrp 
        + financialObj.appearanceProtection.financial.msrp 
        + financialObj.connectedVehicle.financial.msrp 
        + financialObj.warranty.financial.msrp 
        + financeObj.options.total 
        + financeObj.accessories.total 
        - financeObj.tradeInValue 
        - financeObj.specialIncentives 
        - financeObj.incentives.taxable.total 
        + financialObj.freight 
        + financialObj.pde
        + financeObj.financeValues[this.FinanceTermIndex].ppsa
        financeObj.subtotalTaxed = financeObj.subtotal + (financeObj.financeValues[this.FinanceTermIndex].gstAmount + financeObj.financeValues[this.FinanceTermIndex].pstAmount);
        financeObj.subtotalTaxes = financeObj.financeValues[this.FinanceTermIndex].gstAmount + financeObj.financeValues[this.FinanceTermIndex].pstAmount;

        financeObj.subtotalWithFees = financeObj.subtotal + financeObj.feesAndLevies.total + financialObj.adminServiceFees;
        financeObj.subtotalWithFeesTaxed = financeObj.subtotalWithFees + financeObj.subtotalTaxes
        //financeObj.subtotalWithFeesTaxes = financeObj.subtotalWithFees * financeObj.tax;

        financeObj.subtotalWithRebates = financeObj.subtotal;
        financeObj.subtotalWithRebatesTaxed = financeObj.subtotalWithRebates + financeObj.subtotalTaxes
        //financeObj.subtotalWithRebatesTaxes = financeObj.subtotalWithRebates * financeObj.tax;

        financeObj.subtotalWithFeesWithRebates = financeObj.subtotalWithFees;
        financeObj.subtotalWithFeesWithRebatesTaxed = financeObj.subtotalWithFeesWithRebates + financeObj.subtotalTaxes
        //financeObj.subtotalWithFeesWithRebatesTaxes = financeObj.subtotalWithFeesWithRebates * financeObj.tax;

        financeObj.balanceToFinance = financeObj.subtotal - financeObj.incentives.nonTaxable.total - financeObj.downPaymentValue - financeObj.evRebates.total.finance;
        financeObj.balanceToFinanceTaxed = financeObj.subtotalTaxed - financeObj.incentives.nonTaxable.total - financeObj.downPaymentValue;
        financeObj.balanceToFinanceWithFees = financeObj.subtotalWithFees - financeObj.incentives.nonTaxable.total - financeObj.downPaymentValue;
        financeObj.balanceToFinanceWithFeesTaxed = financeObj.subtotalWithFeesTaxed - financeObj.incentives.nonTaxable.total - financeObj.downPaymentValue;
        financeObj.balanceToFinanceWithRebates = financeObj.subtotalWithRebates - financeObj.incentives.nonTaxable.total - financeObj.downPaymentValue - financeObj.evRebates.total.finance;
        financeObj.balanceToFinanceWithRebatesTaxed = financeObj.subtotalWithRebatesTaxed - financeObj.incentives.nonTaxable.total - financeObj.downPaymentValue - financeObj.evRebates.total.finance;
        financeObj.balanceToFinanceWithFeesWithRebates = financeObj.subtotalWithFeesWithRebates - financeObj.incentives.nonTaxable.total - financeObj.downPaymentValue - financeObj.evRebates.total.finance;
        financeObj.balanceToFinanceWithFeesWithRebatesTaxed = financeObj.subtotalWithFeesWithRebatesTaxed - financeObj.incentives.nonTaxable.total - financeObj.downPaymentValue - financeObj.evRebates.total.finance;

        return financeObj;
    }

    get ExteriorColorInParam() {
        let exterior;

        const params = getParams();

        if (params['exterior'] && params['exterior'][0])
            exterior = params['exterior'][0];

        return exterior;
    }

    get InteriorColorInParam() {
        let interior;

        const params = getParams();

        if (params['interior'] && params['interior'][0])
            interior = params['interior'][0];

        return interior;
    }

    SetSelectedColorsFromParams() {
        if (this.ExteriorColorInParam !== null && (this.SelectedColourExterior === null || this.SelectedColourExterior.code !== this.ExteriorColorInParam)) {
            //console.log('exteriorColor:', this.ExteriorColorInParam);
            Object.entries(this.Colours.visual.exteriors).map((Colour, index) => {
                if (Colour[1]['code'] === this.ExteriorColorInParam) {
                    this.SelectedColourExteriorIndex = index;
                    //console.log('found the matched ext color!');
                }
            });
        }

        if (this.InteriorColorInParam !== null && (this.SelectedColourInterior === null || this.SelectedColourInterior.code !== this.InteriorColorInParam)) {
            //console.log('interiorColor:', this.InteriorColorInParam);
            this.Colours.visual.interiors.map((Colour, index) => {
                if (Colour.code === this.InteriorColorInParam) {
                    this.SelectedColourInteriorIndex = index;
                    //console.log('found the matched int color!');
                }
            });
        }
    }

    /**
     * getAccessories
     */
    getAccessories() {
        const accessoriesObj = JSON.parse(sessionStorage.getItem(Constants.SelectedAccessories));
        let accessories = {};
        accessories.total = Math.round((accessoriesObj !== null ? accessoriesObj.reduce((total, accessorie) => total + accessorie.price, 0) : 0) * 100) / 100;
        accessories.total_residual_value = Math.round((accessoriesObj !== null ? accessoriesObj.reduce((total, accessorie) => total + accessorie.residual_value, 0) : 0) * 100) / 100;
        accessories.detail = accessoriesObj !== null ? { ...accessoriesObj } : {};
        return accessories;
    }

    /**
     * getOptions
     */
    getOptions() {
        // TODO: WHY ARE WE LOADING FROM SESSION STORAGE WHEN THIS OBJECT HOLDS AND LOAD IT ALREADY ? 
        const selectedWheel = JSON.parse(sessionStorage.getItem(Constants.SelectedWheel)) || {};
        let selectedExteriorColour = JSON.parse(sessionStorage.getItem(Constants.DefaultExteriorColour));
        let selectedInteriorColour = JSON.parse(sessionStorage.getItem(Constants.DefaultInteriorColour));
        if (sessionStorage.getItem(Constants.SelectedExteriorColour)) {
            selectedExteriorColour = JSON.parse(sessionStorage.getItem(Constants.SelectedExteriorColour));
        }
        if (sessionStorage.getItem(Constants.SelectedInteriorColour)) {
            selectedInteriorColour = JSON.parse(sessionStorage.getItem(Constants.SelectedInteriorColour));
        }

        const selectedPackage = this.SelectedPackage;
        const selectedNonModelPackage = this.SelectedNonModelPackage;
        const selectedWarrantyPackage = this.SelectedWarrantyPackage;
        const selectedConnectedVehiclePackage = this.SelectedConnectedVehiclePackage;

        let options = {};
        // displayedTotal is used in the mazdaPrice
        options.displayedTotal = (selectedInteriorColour?.price ? selectedInteriorColour.price : 0) 
        + (selectedExteriorColour?.price ? selectedExteriorColour.price : 0)
        + (selectedNonModelPackage?.financial?.msrp ? selectedNonModelPackage.financial.msrp : 0) 
        + (selectedWarrantyPackage?.financial?.msrp ? selectedWarrantyPackage.financial.msrp : 0) 
        + (selectedConnectedVehiclePackage?.financial?.msrp ? selectedConnectedVehiclePackage.financial.msrp : 0);

        options.total = (selectedWheel.price ? selectedWheel.price : 0) +
                        + (selectedExteriorColour && selectedExteriorColour.price ? selectedExteriorColour.price : 0)
                        + (selectedInteriorColour && selectedInteriorColour.price ? selectedInteriorColour.price : 0);

        options.wheels = selectedWheel;
        options.interiorColour = selectedInteriorColour;
        options.exteriorColour = selectedExteriorColour;
        options.model_option_package = selectedPackage;
        options.universal_package = selectedNonModelPackage;
        options.warranty_package = selectedWarrantyPackage;
        options.connected_vehicle_package = selectedConnectedVehiclePackage;
        return options;

    }

    /**
     * getDetailedOptions
     * 
     * This version is for the calculated cash which has a separated entry for protection, accessories, connectivty
     */
    getDetailedOptions() {
        const selectedWheel = JSON.parse(sessionStorage.getItem(Constants.SelectedWheel)) || {};
        let selectedExteriorColour = JSON.parse(sessionStorage.getItem(Constants.DefaultExteriorColour));
        let selectedInteriorColour = JSON.parse(sessionStorage.getItem(Constants.DefaultInteriorColour));
        if (sessionStorage.getItem(Constants.SelectedExteriorColour)) {
            selectedExteriorColour = JSON.parse(sessionStorage.getItem(Constants.SelectedExteriorColour));
        }
        if (sessionStorage.getItem(Constants.SelectedInteriorColour)) {
            selectedInteriorColour = JSON.parse(sessionStorage.getItem(Constants.SelectedInteriorColour));
        }
        let selectedPackageIndex = JSON.parse(sessionStorage.getItem(Constants.SelectedPackageIndex));
        let selectedPackage = this.Packages?.packages.filter(pack => pack.type === 'model_option_package');
        if(selectedPackageIndex !== null)
            selectedPackage = selectedPackage[selectedPackageIndex];

        let selectedNonModelPackageIndex = JSON.parse(sessionStorage.getItem(Constants.SelectedNonModelPackageIndex));
        let selectedNonModelPackage = this.Packages?.packages.filter(pack => pack.type === 'universal_package');
        if(selectedNonModelPackageIndex !== null)
            selectedNonModelPackage = selectedNonModelPackage[selectedNonModelPackageIndex];

        let selectedWarrantyIndex = JSON.parse(sessionStorage.getItem(Constants.SelectedWarrantyIndex));
        let selectedWarrantyPackage = this.Packages?.packages.filter(pack => pack.type === 'universal_package' && (pack.package_type === 'Warranty' || pack.package_type === 'Garantie'));
        if(selectedWarrantyIndex !== null)
            selectedWarrantyPackage = selectedNonModelPackage[selectedWarrantyIndex];            

        let selectedConnectedVehicleIndex = JSON.parse(sessionStorage.getItem(Constants.SelectedConnectedVehicleIndex));
        let selectedConnectedVehiclePackage = this.Packages?.packages.filter(pack => pack.type === 'universal_package' && (pack.package_type === 'Connected Vehicle' || pack.package_type === 'Véhicule Connecté'));
        if(selectedConnectedVehicleIndex !== null)
            selectedConnectedVehiclePackage = selectedConnectedVehiclePackage[selectedConnectedVehicleIndex];  

        let options = {};
        options.displayedTotal = (selectedInteriorColour?.price ? selectedInteriorColour.price : 0) 
        + (selectedExteriorColour?.price ? selectedExteriorColour.price : 0) 
        + /*(selectedPackage?.financial?.msrp ? selectedPackage.financial.msrp : 0) +*/ (selectedNonModelPackage?.financial?.msrp ? selectedNonModelPackage.financial.msrp : 0) 

        options.total = (selectedInteriorColour?.price ? selectedInteriorColour.price : 0) 
        + (selectedExteriorColour?.price ? selectedExteriorColour.price : 0) 
        + (selectedWheel.price ? selectedWheel.price : 0) 
        + (selectedWheel.tpms ? selectedWheel.tpms : 0)
        + (selectedWheel.install_cost ? selectedWheel.install_cost : 0);
        //+ (selectedConnectedVehiclePackage?.financial?.msrp ? selectedConnectedVehiclePackage.financial.msrp : 0);

        options.wheels = selectedWheel;
        options.interiorColour = selectedInteriorColour;
        options.exteriorColour = selectedExteriorColour;
        options.model_option_package = selectedPackage;
        options.universal_package = selectedNonModelPackage;
        options.warranty_package = selectedWarrantyPackage;
        options.connected_vehicle_package = selectedConnectedVehiclePackage;        
        return options;

    }

    /**
     * getSupValueFromFee
     */
    getSupValueFromFee(fee) {
        let sup = null;

        switch (fee) {
            case 'A/C Tax':
                sup = '3';
                break;
            case 'Tire':
                sup = '6';
                break;
            case 'OMVIC':
                sup = '4';
                break;
            case 'AMVIC':
                sup = '5';
                break;
            case 'Administration Fee':
                sup = '9';
                break;
            default:
                sup = null;
                break;
        }
        return sup;
    }

    /**
     * getFeesAndLeaves
     */
    getFeesAndLeaves(inCashCalculation, leaseMode) {
        let feesObj = JSON.parse(sessionStorage.getItem(Constants.FinancialObj)) ?.fees || {};
        let feeAndLevies = {};
        const that = this;
        if (feesObj.length) {
            // Filter and remove freight from the fees calculation
            feesObj = feesObj.filter(function (fee) {
                return fee.title !== 'Freight' && fee.title !== 'Administration Fee' && fee.title !== 'PDE'
            });

            // Hardcode the sup value to the label - or TRY TO add it to the JSON data.
            feesObj.forEach((el, index) => {
                feesObj[index] = { ...el, 'sup': that.getSupValueFromFee(el.title) }
            })

            // Add <sup> value to
            if (inCashCalculation) {
                // Filter and remove PDE from the fees calculation in cash calculation and leaving the feesObj intact as it's used for displaying also.
                const feesObjFiltered = feesObj.filter(function (fee) {
                    return fee.title !== 'PDE'
                });
                feeAndLevies.total = feesObjFiltered.reduce((total, fee) => total + fee.price, 0);
            } else {
                feeAndLevies.total = feesObj.reduce((total, fee) => total + fee.price, 0);
            }

            feeAndLevies.detail = [...feesObj];
        } else {
            feeAndLevies.total = 0;
        }
        return feeAndLevies;
    }

    /**
     * getRewardsList
     */
    getRewardsList(loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked) {
        const financialObj = JSON.parse(sessionStorage.getItem('financialObj')) || {};
        const rewardKeys = [/*"loyalty", */'military', 'grad_award', 'first_time_owner'];

        // Grab the whole list of current incentives
        let incentivesList = this.getIncentives(financialObj);
        // console.log('[getRewardsList] incentivesList', incentivesList);

        // Add checked value to corresponding incentives(reward)
        if (loyaltyChecked) {
            incentivesList.loyalty.checked = true;
        }
        if (graduateChecked) {
            incentivesList.grad_award.checked = true;
        }
        if (militaryChecked) {
            incentivesList.military.checked = true;
        }
        if (firstTimeOwnerChecked) {
            incentivesList.first_time_owner.checked = true;
        }        

        let rewardsList = [];

        // Keep the `rewards` incentives only - filter out the rest
        rewardKeys.forEach(key => {
            if (incentivesList[key] && incentivesList[key].checked === true) {
                rewardsList.push(incentivesList[key]);
            }
        });
        // console.log('[getRewardsObj] rewardsList', rewardsList);

        return rewardsList;
    }

    /**
     * getIncentivesObj
     */
    getIncentivesObj(loyaltyChecked, graduateChecked, militaryChecked, firstTimeOwnerChecked, isCashCalculation = false) {
        const financialObj = JSON.parse(sessionStorage.getItem('financialObj')) || {};
        const incentivesKeysTaxable = ['connect'];
        let incentivesKeysNonTaxable;

        // BUSINESS RULE: Loyalty is calculated on cash discount but in financing and leasing it's calculated by TCCI so we exclude it
        if(isCashCalculation)
            incentivesKeysNonTaxable = ["military", 'grad_award', "loyalty", "first_time_owner"];
        else
            incentivesKeysNonTaxable = ["military", 'grad_award', /*"loyalty",*/ "first_time_owner"];

        let incentives = this.getIncentives(financialObj);
        let incentivesObj = {};
        incentivesObj.taxable = {};
        incentivesObj.taxable.details = [];
        incentivesObj.taxable.total = 0;
        incentivesObj.nonTaxable = {};
        incentivesObj.nonTaxable.details = [];
        incentivesObj.nonTaxable.total = 0;
        if (loyaltyChecked) {
            incentives.loyalty.checked = true;
        }
        if (graduateChecked) {
            incentives.grad_award.checked = true;
        }
        if (militaryChecked) {
            incentives.military.checked = true;
        }
        if (firstTimeOwnerChecked) {
            incentives.first_time_owner.checked = true;
        }

        incentivesKeysTaxable.map(incentiveKey => {
            if (incentives[incentiveKey] && incentives[incentiveKey].checked === true) {
                incentivesObj.taxable.details.push(incentives[incentiveKey]);
                incentivesObj.taxable.total += incentives[incentiveKey].cash_value ? incentives[incentiveKey].cash_value : incentives[incentiveKey].value;
            }
        });

        incentivesKeysNonTaxable.map(incentiveKey => {
            if (incentives[incentiveKey] && incentives[incentiveKey].checked === true) {
                incentivesObj.nonTaxable.details.push(incentives[incentiveKey]);
                incentivesObj.nonTaxable.total += incentives[incentiveKey].cash_value ? incentives[incentiveKey].cash_value : incentives[incentiveKey].value;
            }
        });

        return incentivesObj;
    }

    /**
     * getEvRebate
     */
    getEvRebate(financeObj) {
        const tax = this.getTax();        
        const federalTax = this.getGstRate();
        const provincialTax = this.getPstRate();

        let evRebates = {};
        evRebates.total = {
            'cash': 0,
            'lease': 0,
            'finance': 0,
            'federal_tax': 0,
            'provincial_tax': 0,
            'tax': 0,
            'lease_federal_tax': 0,
            'lease_provincial_tax': 0,
            'lease_tax': 0
        }

        if (!financeObj.apr || !financeObj.lease)
            return evRebates;

        evRebates.details = [];

        const evRebateObj = financeObj.ev_rebates;

        evRebateObj.map(rebate => {
            if(rebate.lease.length === 0 || rebate.apr.length === 0)
                return;

            const filteredLeaseItems = rebate.lease.filter(leaseItem => Number(leaseItem.term) === Number(this._leaseTerm));
            const leaseProRatedRebate =  filteredLeaseItems.length > 0 ? filteredLeaseItems[0].rate : 0;
            
            const filteredFinanceItems = rebate.apr.filter(financeItem => Number(financeItem.term) === Number(this._financeTerm));
            const financeProRatedRebate = filteredFinanceItems.length > 0 ? filteredFinanceItems[0].rate : 0;

            const calculateTaxes = this.hasEvFinancingTaxes(getProvince());
            const evRebate = {
                cash: rebate.cash,
                tax_cash: calculateTaxes ? rebate.cash - (rebate.cash / (1 + tax)) : 0,
                lease: rebate.cash * leaseProRatedRebate,
                finance: rebate.cash * financeProRatedRebate,
                title: rebate.province
            }
            evRebates.details.push(evRebate);

            evRebates.total.cash += evRebate.cash; // this is with taxe include;
            evRebates.total.finance += evRebate.finance; // this is with taxe include;
            evRebates.total.lease += evRebate.lease; // this is with taxe include;

            if (rebate.province === "federal")
                evRebates.total.lease_federal_tax += Math.round((evRebates.total.lease * tax) * 100) / 100;
            else
                evRebates.total.lease_provincial_tax += Math.round((rebate.cash * leaseProRatedRebate * tax) * 100) / 100;
        });


        // Calulate the taxes on the sums of all the ev rebates
        evRebates.total.lease_tax = (evRebates.total.lease * tax);

        return evRebates;
    }

    /**
     * get incentive list associated with the financial object
     */
    getIncentives(financialObj) {
        let incentives = {};
        if (financialObj.incentive_programs)
            financialObj.incentive_programs.forEach(incentive => {
                incentives[incentive.type] = incentive;
            });
        return incentives;
    }

    /**
     * parseAccessoriesData
     */
    parseAccessoriesData(accessoriesData) {
        var data = [];
        const popularData = [];
        let formatedData = {};

        for (const index in accessoriesData) {
            data.push(accessoriesData[index]);
        }

        data.forEach((accessory, index) => {
            accessory.index = index;
            if (accessory.popular === true) {
                popularData.push(accessory);
            }
        })

        if (data.length) {
            formatedData = this.groupBy(data, 'category');
            formatedData['All'] = data;
            if (popularData.length > 0) {
                formatedData['Popular'] = popularData;
            }
        }
        return (formatedData);
    }

    /**
     * getTax - returns the HST from PST and GST
     */
    getTax() {
        const result =  this.getGstRate() + this.getPstRate();
        return result;
    }

    /**
     * getGstRate - return the gst tax rate
     */
    getGstRate() {
        if (this._gstRate === 0) 
            this._gstRate = Number(sessionStorage.getItem('FinancialProvider_GST'));
        
        const result = Number(this._gstRate) / 100;
        return result;
    }


    /**
     * getPstRate - return the provincial tax
     */
    getPstRate() {
        if (this._pstRate === 0) 
            this._pstRate = Number(sessionStorage.getItem('FinancialProvider_PST'));

        const result = Number(this._pstRate) / 100;
        return result;
    }

    /*
     *   This is the new version of the Loan Informational APR calculation.
     */
    getLoanInformationalAprRate() {
        const financeElement = this.FinancialInfo.calculatedFinance.financeValues[this.FinanceTermIndex];

        const term = financeElement.term;
        
        const monthly = financeElement.monthly;
      
        const capitalizedCost = financeElement.loanAmount;

        const adminFees = getProvince() === "QC" ?  this.FinancialInfo.adminServiceFees : 0;        

        const result = RATE(term, monthly, -capitalizedCost +adminFees, 0, 0);

        const toReturn = Number(result * 12 * 100);

        return toReturn;
        //return customRound(result * 12 * 100, 2);
    }


      
    /*
     *   This is the new version of the Lease Informational APR calculation.
     */
    getLeaseInformationalAprRate() {
        const leaseElement = this.FinancialInfo.calculatedLease.leaseValues[this.LeaseTermIndex];

        const term = leaseElement.term;
        
        const monthly = leaseElement.monthly;
      
        const capitalizedCost = leaseElement.capitalizedCost;

        const adminFees = getProvince() === "QC" ?  this.FinancialInfo.adminServiceFees : 0;

        const retailCash = this.FinancialInfo.calculatedLease.mazdaRetailCash;

        const leaseEndValue = leaseElement.leaseEndValue;

        const result = RATE(term, monthly, -capitalizedCost +adminFees + retailCash, Number(leaseEndValue), 1);

        //return customRound(result * 12 * 100, 2);
        return Number(result * 12 * 100);
    }

    /*
     * getMaxDownPayment / tradeIn
     *
     */
    getMaxDownPayment(financialObj) {
        if(!this.FinancialInfo)
            return 0;

        if(!this.SelectedModel)
            return 0;

        if(!this.SelectedPackage)
            return 0;

        const freight = this.FinancialInfo.fees.filter((fee) => fee.title === 'Freight').length ? this.FinancialInfo.fees.filter((fee) => fee.title === 'Freight')[0].price : 0;
        const pde = this.FinancialInfo.fees.filter((fee) => fee.title === 'PDE').length ? this.FinancialInfo.fees.filter((fee) => fee.title === 'PDE')[0].price : 0;
        const acTax = this.FinancialInfo.fees.filter((fee) => fee.title === 'A/C Tax').length ? this.FinancialInfo.fees.filter((fee) => fee.title === 'A/C Tax')[0].price : 0;
        const exciseTax = this.FinancialInfo.fees.filter((fee) => fee.title === 'Federal Excise Tax').length ? this.FinancialInfo.fees.filter((fee) => fee.title === 'Federal Excise Tax')[0].price : 0;
        const amvic = this.FinancialInfo.fees.filter((fee) => fee.title === 'AMVIC').length ? this.FinancialInfo.fees.filter((fee) => fee.title === 'AMVIC')[0].price : 0;
        const omvic = this.FinancialInfo.fees.filter((fee) => fee.title === 'OMVIC').length ? this.FinancialInfo.fees.filter((fee) => fee.title === 'OMVIC')[0].price : 0;
        const tireStewardshipFee = this.FinancialInfo.fees.filter((fee) => fee.title === 'Tire Shewardship Fee').length ? this.FinancialInfo.fees.filter((fee) => fee.title === 'Tire Shewardship Fee')[0].price : 0;
        const oil = this.FinancialInfo.fees.filter((fee) => fee.title === 'Oil').length ? this.FinancialInfo.fees.filter((fee) => fee.title === 'Oil')[0].price : 0;

        const mazdaCashIncentive = this.FinancialInfo.incentive_programs.filter((fee) => fee.title === 'mazda_retail_cash').length ? this.FinancialInfo.incentive_programs.filter((fee) => fee.title === 'mazda_retail_cash')[0].price : 0;

        // LEASE AND ADMIN SERVICE FEES ARE THE SAME STARTING 1ST JANUARY 2024 // 595
        //const leaseServiceFees = summaryCalculator.FinancialInfo.fees.filter((fee) => fee.title === 'Administration Fee').length ? summaryCalculator.FinancialInfo.fees.filter((fee) => fee.title === 'Administration Fee')[0].price : 0;
        const adminServiceFees = this.FinancialInfo.fees.filter((fee) => fee.title === 'Administration Fee').length ? this.FinancialInfo.fees.filter((fee) => fee.title === 'Administration Fee')[0].price : 0;
        
        // Loyalty can be percentage or cash amount reduction. Excluding for now
        const loyaltyValue = this.LoyaltyChecked ? this.FinancialInfo.incentive_programs.find(x => x.type === "loyalty").cash_value : 0;
        const graduatePrice = this.GraduateChecked ? this.FinancialInfo.incentive_programs.find(x => x.type === "grad_award").value : 0;
        const militaryPrice= this.MilitaryChecked ? this.FinancialInfo.incentive_programs.find(x => x.type === "military").value : 0;
        const firstTimeOwnerPrice = this.FirstTimeOwnerChecked ? this.FinancialInfo ? this.FinancialInfo.incentive_programs.find(x => x.type === "first_time_owner").value : 0 : 0;

        const incentives = mazdaCashIncentive + graduatePrice + militaryPrice + firstTimeOwnerPrice + this.FinancialInfo.calculatedFinance.specialIncentives;

        const options = financialObj.calculatedFinance.options.total  // Colors +Wheels
                        //+ this.SelectedNonModelPackage.financial.msrp
                        //+ this.SelectedWarrantyPackage.financial.msrp // Warranty 
                        //+ this.SelectedConnectedVehiclePackage.financial.msrp // Connected Vehicle 
                        + financialObj.calculatedFinance.accessories.total; // Accessories

        const totalMSRP = this.SelectedModel.financial.msrp
            + this.SelectedPackage.financial.msrp // Actual Car packages          
            + options
            + exciseTax + freight + pde // Excise is 100$ hardcoded in the excel sheet, freight can vary. 
            + (this.IncludeFees ? acTax + amvic + omvic + tireStewardshipFee + oil : 0);

        // Fetch residual value from the calls
        const element = financialObj.calculatedLease.leaseValues.find(x => x.term === 36);

        const maxDownPayment = totalMSRP
        + adminServiceFees
        + element.ppsa
        - incentives
        - this.FinancialInfo.calculatedLease.evRebates.total.lease
        - (element.downPaymentLeaseEndValue ? element.downPaymentLeaseEndValue : 0) // Use this variable for the 24000 km annual mileage
        - 100;

        console.log("maxDownPayment", maxDownPayment);
        return maxDownPayment;
    }    
    
    /*
     * isRetailerMode - checks if we are in a retailer mode
     *
     */    
    async isRetailerMode() {
        if(!window.bnp_retailer_mode) {
            // FLUSH THE DEALER VARS (Fix issue of dealer map stuck with the dealer vars one)
            sessionStorage.removeItem('bnp_dealerVars');
            
            return false;
        }

        const urlParams = getParams();
        if (urlParams['DealerID']) {
            // Fix use case that we switch from different iframe session from switching dealers website
            if(sessionStorage.getItem('bnp_dealerVars')) {
                const dealerVars = JSON.parse(sessionStorage.getItem('bnp_dealerVars'));
                if(dealerVars.dealerId !== urlParams['DealerID'][0])
                    sessionStorage.removeItem('bnp_dealerVars');
            }

            if(!sessionStorage.getItem('bnp_dealerVars')) {
                const dealerId = urlParams['DealerID'][0];
                const dealerData = await this._apiService.getDealerDataById(dealerId);
                if (dealerData.data) {
                    const dealerName = dealerData.data.name;
                    const provinceCode = dealerData.data.province.province_code;

                    console.log(dealerId, dealerName, provinceCode);
                    const dealerVars = JSON.stringify({dealerId: dealerId, dealerName: dealerName, dealerProvinceCode: provinceCode})
                    sessionStorage.setItem('bnp_dealerVars', dealerVars);

                    this.province = provinceCode;
                    this._apiService.province = provinceCode;
                    this._tcciService.province = provinceCode;
                }
            }
        } else {
            // FLUSH THE DEALER VARS (Fix issue of dealer map stuck with the dealer vars one)
            sessionStorage.removeItem('bnp_dealerVars');
        }

        return window.bnp_retailer_mode;
    }

    getDealerVars() {
        if (sessionStorage.getItem('bnp_dealerVars')) {
            return JSON.parse(sessionStorage.getItem('bnp_dealerVars'));
        } else {
            //console.log('something went wrong with DealerVars')
            return null;
        }
    }
    
    // TODO : move to utils class
    shallowClone(obj) {
        return Object.create(
            Object.getPrototypeOf(obj),
            Object.getOwnPropertyDescriptors(obj)
        );
    }

    /*
    * This has been added as a patch as the use state doesnt reflect update the object correctly in its memory reference
    */
    getInstance() {
        return this.shallowClone(this);
    }

    /**
     * is province allowed to include EV rebates
     * @returns {boolean}
     */
    isProvinceAllowedToIncludeRebates() {
        const province = getProvince();
        switch(province) {
            case "BC":
            case "AB":
            case "SK":
            case "MB":
            case "ON":
            case "QC":
                //return true; // RECOMMENTED AS PER TICKET WTCANMAZDAINT-4030
            case "NB":
            case "NS":
            case "PE":
            case "NL":
            case "YT":
            case "NT":
            default:
                return false;
        }
    }

    /**
    * Return if the financed EV is taxable in that province
    */
    hasEvFinancingTaxes(province) {
        console.log("hasEvFinancingTaxes province", province);

        switch (province) {
            case "QC":
                return false;
            case "BC":
            default:
                return true;
        }
    }    
    
    isSelectionPreOrder() {
        let isPreOrder = false;

        if( !this.SelectedModel || !this.SelectedPackage )
            return isPreOrder;

        const model_code = this.SelectedModel.model_code;
        const option_code = this.SelectedPackage.option_code;

        if(window.preOrder) {
            window.preOrder.forEach((item) => {
                if (item.modelCode === model_code && item.modelOption === option_code) {
                    isPreOrder = true;
                }                
            });
        }

        return isPreOrder;
    }

    async forceReloadVehicle(value) {
        //this._needReload = value

        if (this.selectedVehicle.carline) {
            // Trigger the whole vehicle reload
            await this.loadVehicleData(this.selectedVehicle.year, 
                this.selectedVehicle.carline, 
                this.selectedVehicle.trim, 
                this.selectedVehicle.model, 
                this.selectedVehicle.packageCode);

            await this.loadFromFinancialProvider();

            // Force the reset
            window.SummaryCalculator = this;
        }
    }
}
